import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-utility',
  templateUrl: './utility.component.html',
  styleUrls: ['./utility.component.scss']
})
export class UtilityComponent implements OnInit {

  public allProductsData: any = [];

  constructor() { }

  ngOnInit(): void {
  }

  // Get all products from query promotions response
  getAllProducts() {
    let xmlData = {
      "QueryPromotionsResponse": {
        "Promotion": [
          {
            "PromotionId": 2168,
            "PromotionName": "SAVE $0.50 on Betty Crocker® Cake and Frosting (1)",
            "PromotionType": "Default",
            "PromotionFlags": "None",
            "ReceiptText": "Betty Crocker",
            "StartDate": "2014-12-10T13:42:12",
            "EndDate": "2034-04-01T23:59:59.997",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Household",
              "CustomerLimit": 1,
              "ActivationLimit": 1000,
              "DisplayStartDate": "2010-09-14T00:00:00",
              "DisplayEndDate": "2034-04-01T23:59:59",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "on Betty Crocker® Cake and Frosting when you buy BOTH Betty Crocker® SuperMoist® Cake Mix AND Betty Crocker® Ready to Spread Frosting (any flavors/varieties)",
              "DisplayDetail": "Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law.  One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs.RETAILER:  General Mills will reimburse you the face value of this coupon plus 8 cents if submitted in compliance with our redemption policy. Copy available upon request.  Cash value 1/100 cent.  Send to GENERAL MILLS, P.O. Box 880588, El Paso TX 88588-0588 or an authorized clearinghouse.CONSUMER:  No other coupon may be used with this coupon. Consumer pays any sales tax.",
              "ImageURL": "http://d17qf54098xvyo.cloudfront.net/INTEGRATION/imageserver/AOL-2256.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100160009753e+26
            },
            "ProductsQualificationCriteria": {
              "TriggerQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "Products": {
                  "Product": [ 
                    1600016166,
                    1600032320,
                    1600032990,
                    1600037400,
                    1600037410,
                    1600037420,
                    1600037460,
                    1600041777,
                    1600045830,
                    1600045840,
                    1600045900,
                    1600045960,
                    1600046070,
                    1600052440,
                    1600041239,
                    1600045890
                  ]
                }
              },
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1600043030,
                    1600043100,
                    1600043130,
                    1600043230,
                    1600043300,
                    1600043500,
                    1600043600,
                    1600043620,
                    1600043630,
                    1600043740,
                    1600043780,
                    1600043950,
                    1600050250,
                    1600050420,
                    1600052850,
                    1600054230,
                    1600043040
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 4,
                  "StringValue": "Baking"
                },
                {
                  "PromotionAttributeID": 3,
                  "StringValue": "Betty Crocker"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 2169,
            "PromotionName": "Save $0.50 on 2 Betty Crocker® Boxed Potatoes (2)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Betty Crocker",
            "StartDate": "2014-12-10T13:42:12",
            "EndDate": "2034-04-01T23:59:59.997",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Household",
              "CustomerLimit": 100,
              "ActivationLimit": 1000,
              "DisplayStartDate": "2010-09-14T00:00:00",
              "DisplayEndDate": "2034-04-01T23:59:59",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "on 2 Betty Crocker® Boxed Potatoes when you buy TWO any flavor Betty Crocker® boxed Potatoes (Except Potato Buds® and Betty Crocker® Pouch)",
              "DisplayDetail": "Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law.  One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs.RETAILER:  General Mills will reimburse you the face value of this coupon plus 8 cents if submitted in compliance with our redemption policy. Copy available upon request.  Cash value 1/100 cent.  Send to GENERAL MILLS, P.O. Box 880588, El Paso TX 88588-0588 or an authorized clearinghouse.CONSUMER:  No other coupon may be used with this coupon. Consumer pays any sales tax.",
              "ImageURL": "http://d17qf54098xvyo.cloudfront.net/INTEGRATION/imageserver/AOL-2315.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100160009787e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1600017722,
                    1600017723,
                    1600039510,
                    1600040670,
                    1600041820,
                    1600041880,
                    1600046410,
                    1600050520,
                    1600014671,
                    1600015626,
                    1600015627,
                    1600027441,
                    1600027442,
                    1600027444,
                    1600027445,
                    1600027446,
                    1600027488,
                    1600027489
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 4,
                  "StringValue": "Grocery"
                },
                {
                  "PromotionAttributeID": 3,
                  "StringValue": "Betty Crocker"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 2170,
            "PromotionName": "Save $0.50 on Chex Mix® (3)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Chex Mix",
            "StartDate": "2014-12-10T13:42:12",
            "EndDate": "2034-04-01T23:59:59.997",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Household",
              "CustomerLimit": 0,
              "ActivationLimit": 1000,
              "DisplayStartDate": "2010-09-14T00:00:00",
              "DisplayEndDate": "2034-04-01T23:59:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "on Chex Mix® when you buy ONE any flavor 4.5 OZ. OR LARGER Chex Mix® OR Chex® 100 Calorie Snack",
              "DisplayDetail": "Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law.  One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs.RETAILER:  General Mills will reimburse you the face value of this coupon plus 8 cents if submitted in compliance with our redemption policy. Copy available upon request.  Cash value 1/100 cent.  Send to GENERAL MILLS, P.O. Box 880588, El Paso TX 88588-0588 or an authorized clearinghouse.CONSUMER:  No other coupon may be used with this coupon. Consumer pays any sales tax.",
              "ImageURL": "http://d17qf54098xvyo.cloudfront.net/INTEGRATION/imageserver/AOL-2258.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100160009809e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1600015110,
                    1600015135,
                    1600015136,
                    1600015810,
                    1600015840,
                    1600015940,
                    1600015950,
                    1600015980,
                    1600015990,
                    1600016060,
                    1600016490,
                    1600012609,
                    1600016239,
                    1600019639,
                    1600028345,
                    1600028346,
                    1600047433
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 4,
                  "StringValue": "Snack &amp; Candy"
                },
                {
                  "PromotionAttributeID": 3,
                  "StringValue": "Snacks"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 2866,
            "PromotionName": "10% Off Wine With Card Promotion (Raincheck)",
            "PromotionType": "Raincheck",
            "PromotionFlags": "None",
            "ReceiptText": "10% OFF WINE W/C",
            "StartDate": "2015-05-15T00:00:00",
            "EndDate": "2031-12-31T23:59:59.997",
            "CustomerSegmentDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0,
              "CustomerSegments": {
                "CustomerSegmentID": 4
              }
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 89899
            },
            "ProductsQualificationCriteria": "",
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 13944,
            "PromotionName": "Calico Nuts 3 for $10",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Calico Nuts",
            "StartDate": "2021-02-10T00:00:00",
            "EndDate": "2024-12-31T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "RetailerFixedValueCoupon": {
              "Number": 71091,
              "CentsOff": 200
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 3,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    67330510978,
                    67330510979,
                    67330510980
                  ]
                }
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 13949,
            "PromotionName": "Free Curbside Pickup Test",
            "PromotionType": "Trade",
            "PromotionFlags": "IsBonusPromotion",
            "ReceiptText": "Free Pickup",
            "StartDate": "2023-01-17T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 495
            },
            "TransactionQualificationCriteria": {
              "Threshold": 3500
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 15881,
            "PromotionName": "EW Test - 5% Limit $25",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "5% Limit Test",
            "StartDate": "2022-05-27T00:00:00",
            "EndDate": "2023-03-31T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Household",
              "CustomerLimit": 0
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 88210
            },
            "TransactionQualificationCriteria": {
              "Threshold": 2500
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16016,
            "PromotionName": "Boy Scout 2023 Test 83200",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16020,
            "PromotionName": "Boy Scout 2023 Test 83209",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16021,
            "PromotionName": "Boy Scout 2023 Test 83210",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16022,
            "PromotionName": "Boy Scout 2023 Test 83211",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16023,
            "PromotionName": "Boy Scout 2023 Test 83212",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16024,
            "PromotionName": "Boy Scout 2023 Test 83213",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16025,
            "PromotionName": "Boy Scout 2023 Test 83214",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16026,
            "PromotionName": "Boy Scout 2023 Test 83215",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16027,
            "PromotionName": "Boy Scout 2023 Test 83216",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16028,
            "PromotionName": "Boy Scout 2023 Test 83217",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16029,
            "PromotionName": "Advertising Test Promotion",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "",
            "StartDate": "2022-12-01T00:00:00",
            "EndDate": "2023-01-31T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71091,
              "CentsOff": 100
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 4011
                }
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16030,
            "PromotionName": "Advertising Test Promotion 2",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Discount",
            "StartDate": "2022-12-01T00:00:00",
            "EndDate": "2023-01-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71091,
              "CentsOff": 100
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 4050
                }
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16031,
            "PromotionName": "2X Test multiplier Store Paper Coupon 2023",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "",
            "StartDate": "2022-12-15T00:00:00",
            "EndDate": "2023-01-31T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 1,
            "TransactionQualificationCriteria": {
              "Threshold": 1
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16035,
            "PromotionName": "ADVANTAGE MAIL 012523 SWEET BABY RAYS",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Sweet Baby Ray",
            "StartDate": "2022-12-16T00:00:00",
            "EndDate": "2023-01-31T23:59:59.997",
            "CustomerSegmentDistribution": {
              "CustomerLevel": "Household",
              "CustomerLimit": 0,
              "CustomerSegments": {
                "CustomerSegmentID": 1
              }
            },
            "TransactionLimit": 0,
            "RetailerNetValueCoupon": {
              "Number": 71051,
              "NetValue": 198
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1340934341,
                    1340935175,
                    1340935231,
                    1340991237
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16036,
            "PromotionName": "Advertising Test #3",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scout",
            "StartDate": "2023-01-01T00:00:00",
            "EndDate": "2023-01-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16040,
            "PromotionName": "SAVE 50¢ ON FIVE when you buy FIVE CUPS any var (154599)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Yoplait",
            "StartDate": "2023-01-10T14:56:04.17",
            "EndDate": "2023-02-16T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "SAVE 50¢ ON FIVE when you buy FIVE CUPS any variety Yoplait® Yogurt (Includes Original, Light, Whips!®, Lactose Free, Greek, OR Oui™ by Yoplait®)",
              "DisplayDetail": "Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: General Mills will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100 cent. Send to GENERAL MILLS 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse. ©Yoplait USA, Inc.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/824/333824_dedfd547-e572-4d01-a169-fb8369d14f20.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100704701546e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 5,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7047000109,
                    7047000128,
                    7047000129,
                    7047000300,
                    7047000302,
                    7047000303,
                    7047000307,
                    7047000310,
                    7047000312,
                    7047000313,
                    7047000319,
                    7047000321,
                    7047000323,
                    7047000643,
                    7047000650,
                    7047000652,
                    7047000653,
                    7047000654,
                    7047000655,
                    7047000661,
                    7047000665,
                    7047028447,
                    7047027831,
                    7047050484,
                    7047043329,
                    7047043332,
                    7047043333,
                    7047043579,
                    7047045725,
                    7047045726,
                    7047045913,
                    7047045915,
                    7047045916,
                    7047045578,
                    7047040021,
                    7047040022,
                    7047044614,
                    7047044616,
                    7047049646,
                    7047049647,
                    7047049649,
                    7047049651,
                    7047049652,
                    7047049653,
                    7047049654,
                    7047010376,
                    7047011414,
                    7047014212,
                    7047015412,
                    7047015413,
                    7047015865,
                    7047015964,
                    7047016324,
                    7047015832,
                    7047015965,
                    7047018022,
                    7047018023,
                    7047018024,
                    7047018025,
                    7047018119,
                    7047018121,
                    7047018495,
                    7047018959,
                    7047018961,
                    7047018963
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Yoplait®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16065,
            "PromotionName": "SAVE $1.50 ON TWO when you buy TWO PACKS any va (154611)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Yoplait",
            "StartDate": "2023-01-10T14:56:04.81",
            "EndDate": "2023-02-16T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 150,
              "DisplaySummary": "SAVE $1.50 ON TWO when you buy TWO PACKS any variety Yoplait® Yogurt Multipack (Includes 8-Pack Fridge Pack, 4-Pack Fridge Pack, Beverage, Go-GURT®, Kids® Cup Yogurt 8CT, OR Trix® Yogurt 8CT)",
              "DisplayDetail": "Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: General Mills will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100 cent. Send to GENERAL MILLS 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse. ©Yoplait USA, Inc.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/827/333827_2cf9dda1-374d-480a-9b7b-37611df212bd.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100704701546e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7047043826,
                    7047013767,
                    7047013768,
                    7047013772,
                    7047013773,
                    7047013778,
                    7047040387,
                    7047040389,
                    7047040391,
                    7047040396,
                    7047014171,
                    7047013779,
                    7047017997
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Yoplait®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16071,
            "PromotionName": "$1.00 OFF any ONE (1) package of Sparkle® Paper (615402)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Sparkle",
            "StartDate": "2023-01-10T14:56:05.013",
            "EndDate": "2023-02-14T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-13T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "$1.00 OFF any ONE (1) package of Sparkle® Paper Towels, 6 roll or larger",
              "DisplayDetail": "Consumer:  LIMIT 1 COUPON PER PURCHASE.  ANY OTHER USE CONSTITUTES FRAUD.  Void if transferred, sold, auctioned, reproduced, altered from original, or where prohibited or restricted by law. Consumer pays sales tax.  Good only in the USA, APO’s, &amp; FPO’s. Cash value .001¢.  Retailer:  Georgia-Pacific will reimburse you the face value of this coupon plus 8¢ if submitted in compliance with our coupon redemption policy (GP.com). Retailer must present invoices verifying stock purchases are consistent with redeemed coupons upon request. Mail to: Georgia-Pacific Consumer Products 1694, NCH Marketing Services, P.O. Box 880001, El Paso, TX 88588-0001. Georgia-Pacific Consumer Products participates in the CIC® Member Coupon Integrity Program. ©2022 Georgia-Pacific Consumer Products. All rights reserved. Unless otherwise noted, all trademarks are owned by or licensed to Georgia-Pacific Consumer Products.  CIC is a trademark of Coupon Information Corporation.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/728/333728_c012a737-eb13-4c5d-9b1d-bd2c17bd5e2d.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100304006154e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3040001380,
                    3040021646,
                    3040021526,
                    3040021736,
                    3040021790,
                    3040021975,
                    3040022134,
                    3040022130
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Sparkle®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16082,
            "PromotionName": "Save $2.00 $2.00 on any ONE (1) Mucinex or Dely (203172)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "MUCINEX or DELSYM",
            "StartDate": "2023-01-10T14:56:05.34",
            "EndDate": "2023-02-02T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-04T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 $2.00 on any ONE (1) Mucinex or Delysm Product (excludes Instasoothe)",
              "DisplayDetail": "Consumer and Retailer: LIMIT ONE (1) COUPON PER PURCHASE OF SPECIFIED PRODUCT AND QUANTITY  STATED.  NOT TO BE COMBINED WITH ANY OTHER COUPON(S). LIMIT OF TWO (2) LIKE COUPONS IN SAME SHOPPING TRIP. VOID IF REPRODUCED, PURCHASED, TRADED OR SOLD. ANY OTHER USE CONSTITUTES FRAUD. Consumer: You pay any sales tax. Retailer: You are authorized to act as our agent and redeem this coupon in acceptance with RB Coupon Redemption Policy: face value plus 8¢. Send coupons to: RB Health. Inmar Dept. #63824, 1 Fawcett Drive, Del Rio, TX 78840. Cash value 1/100 of 1¢. Good only in the U.S.A. Void where prohibited. ©2023 RB HEALTH",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/773/333773_746c3d99-801c-40b1-805f-11923380ad81.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110103638242032e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    36382400820,
                    36382405620,
                    36382405640,
                    36382405718,
                    36382405736,
                    36382400840,
                    36382401064,
                    36382401465,
                    36382401565,
                    36382401665,
                    36382401764,
                    36382401866,
                    36382402314,
                    36382404124,
                    36382407214,
                    36382407228,
                    36382417163,
                    36382417563,
                    36382425412,
                    36382425612,
                    36382427263,
                    36382427464,
                    36382427663,
                    36382427764,
                    36382483436,
                    36382401067,
                    36382419120,
                    36382419220,
                    36382402328,
                    36382402066,
                    36382419320,
                    36382420120,
                    36382420220,
                    36382421366,
                    36382450066,
                    36382455130,
                    36382460064,
                    36382492630,
                    36382458616,
                    36382458716,
                    36382468616,
                    36382459024,
                    36382468824,
                    36382426566,
                    36382454166,
                    36382454266,
                    36382427864,
                    36382424220,
                    36382401470,
                    36382426268,
                    36382481991,
                    36382499508,
                    36382405025,
                    36382405026,
                    36382421367,
                    36382460069,
                    36382460070,
                    36382460071,
                    36382460072,
                    36382484827,
                    36382484828,
                    36382421467,
                    36382499514,
                    36382499526
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "MUCINEX® or DELSYM®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16084,
            "PromotionName": "$3.00 OFF any ONE (1) Burt’s Bees Kids™ Cough S (011068)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Burt's Bees Kids",
            "StartDate": "2023-01-10T14:56:05.417",
            "EndDate": "2023-02-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-03T03:01:00",
              "DisplayEndDate": "2023-02-06T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "$3.00 OFF any ONE (1) Burt’s Bees Kids™ Cough Syrup",
              "DisplayDetail": "CONSUMER: Only one coupon is redeemable per purchase. RETAILER: This coupon will be redeemed for face value on specified products (plus a handling fee) if submitted in compliance with the terms of this offer. Cash value 1/100th of one cent. Limit one coupon per customer. Do Not Double. Coupon is non-reproducible. Coupons cannot be combined. No cash or credit in excess of shelf price for the specified item(s) may be returned to consumer or applied to transaction. Mail properly handled coupons to: L. Perrigo Company (#1565), NCH Marketing, PO Box 880001, El Paso, TX 88588-0001. Perrigo Company is a part of the CIC® Member Coupon Integrity Program",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/666/333666_26500c2c-e5b0-4723-af29-912030a55fd9.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100700300111e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7003016547,
                    7003016548
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Burt’s Bees Kids™"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16095,
            "PromotionName": "$1.00 OFF any ONE (1) ACT® product (excludes Ki (022310)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "ACT",
            "StartDate": "2023-01-10T14:56:05.73",
            "EndDate": "2023-02-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-08T03:01:00",
              "DisplayEndDate": "2023-01-16T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 100,
              "DisplaySummary": "$1.00 OFF any ONE (1) ACT® product (excludes Kids Toothpaste, trial/travel sizes)",
              "DisplayDetail": "Consumer: LIMIT 1 COUPON PER PURCHASE OF SPECIFIED PRODUCT SIZES AND QUANTITY INDICATED. Not to be combined with any other offers. Void if, expired, transferred, sold, auctioned, reproduced or altered from original or where prohibited or restricted by law. Consumer pays sales tax. Good only in the USA, its territories, Puerto Rico and U.S. military bases. Limit 2 identical coupons in the same shopping transaction. ANY OTHER USE CONSTITUTES FRAUD. Retailer: No cash or credit in excess of shelf price after discounts may be returned to consumer. We will reimburse you the face value of this coupon plus 8¢ if submitted in compliance with our Coupon Redemption Policy (available at NCHmarketing.com). Cash value: 1/100 of 1¢. Mail to: Chattem Inc., d/b/a Sanofi Consumer Healthcare, 1050, NCH Marketing Services, P.O. Box 880001, El Paso, TX 88588-0001. Sanofi Consumer Healthcare participates in the CIC® Member Coupon Integrity Program.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/656/333656_d872dbd0-a872-470d-9a0a-8f1dcf62c96e.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100411670223e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4116709350,
                    4116709428,
                    4116709448,
                    4116709565,
                    4116709566,
                    4116709610,
                    4116709650,
                    4116709680,
                    4116709806,
                    4116709444,
                    4116709641,
                    4116709644,
                    4116709614,
                    4116709657,
                    4116709980,
                    4116709200,
                    4116709540,
                    4116709550,
                    4116709365,
                    4116709780,
                    4116709541,
                    4116709551,
                    4116709372,
                    4116709381,
                    4116709921,
                    4116709932,
                    4116709832,
                    4116709408,
                    4116709225,
                    4116709462,
                    4116709471
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "ACT®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16103,
            "PromotionName": "SAVE 75¢ ON ONE when you buy ONE PACKAGE any fl (156271)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Totino's",
            "StartDate": "2023-01-10T14:56:06.01",
            "EndDate": "2023-02-16T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 75,
              "DisplaySummary": "SAVE 75¢ ON ONE when you buy ONE PACKAGE any flavor 50 COUNT OR LARGER Totino's™ Pizza Rolls™ Snacks",
              "DisplayDetail": "Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: General Mills will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100 cent. Send to GENERAL MILLS 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/781/333781_3edbae27-0b07-4316-9f1e-2cf76e84bb4d.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100428001563e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4280010904,
                    4280010915,
                    4280010918,
                    4280010921,
                    4280010924,
                    4280010952,
                    4280010953,
                    4280010954,
                    4280011836,
                    4280011837,
                    4280011838,
                    4280011839
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Totino’s™"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16104,
            "PromotionName": "$0.50 OFF any ONE (1) Silk® Almondmilk (230285)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Silk Almondmilk",
            "StartDate": "2023-01-10T14:56:06.043",
            "EndDate": "2023-02-02T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-04T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "$0.50 OFF any ONE (1) Silk® Almondmilk",
              "DisplayDetail": "CONSUMER: For ultimate consumer redemption only. Redeem this coupon when purchasing in accordance with the terms of this offer. Limit one coupon per purchase. Good only on purchase of product indicated. Any other use constitutes fraud. Coupon non-transferable. You pay sales tax. Void if sold, transferred or reproduced and whenever prohibited by law. RETAILER: Danone US, LLC will reimburse you for the face value of this coupon, plus 8¢ handling, provided you and your customer have complied with the terms of this offer. Consumer must pay all applicable taxes. Coupons not properly redeemed will be voided. Cash value 1/100¢. Limit one coupon per purchase. Void where regulated or prohibited, or if altered, reproduced, sold, purchased, transferred, or exchanged. Any other use constitutes fraud. DO NOT DOUBLE. Send coupons to: CMS Dept. #36632 One Fawcett Drive, Del Rio, TX 78840.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/849/333849_09915df3-5286-4696-8f37-dfb79727157d.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100252932303e+42
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    2529300098,
                    2529300099,
                    2529300119,
                    2529300216,
                    2529300377,
                    2529300379
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Silk® Almondmilk"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16116,
            "PromotionName": "Save $1.00 on any ONE (1) Jif® Squeeze Product (035633)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Jif",
            "StartDate": "2023-01-10T14:56:06.51",
            "EndDate": "2023-02-07T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-09T03:01:00",
              "DisplayEndDate": "2023-02-07T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 on any ONE (1) Jif® Squeeze Product",
              "DisplayDetail": "CONSUMER: Limit one coupon per purchase. Good only in the U.S.A. on purchase of brand/size indicated. Void where regulated or prohibited, or if altered, reproduced, or transferred. Any other use constitutes fraud. Consumer must pay any sales tax. RETAILER: You will be reimbursed in accordance with the Smucker Retail Foods, Inc. Coupon Redemption Policy, to obtain visit www.redemptionpolicy.com/smuckers. Cash value 1/100 of 1¢. Redeem by mailing to: Smucker Retail Foods, Inc. 277, NCH Marketing Services, P.O. Box 880001, El Paso, TX 88588-0001. Good only in the U.S.A. ©/TM/® The J.M. Smucker Company.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/663/333663_43b788a9-71f7-4b57-987b-21a71282aea2.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100515000357e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 5150024545
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Jif®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16117,
            "PromotionName": "SAVE $0.75 off ONE (1) Olive Garden Salad Dress (004596)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Olive Garden Salad",
            "StartDate": "2023-01-10T14:56:06.54",
            "EndDate": "2023-02-07T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-09T03:01:00",
              "DisplayEndDate": "2023-01-24T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 75,
              "DisplaySummary": "SAVE $0.75 off ONE (1) Olive Garden Salad Dressing",
              "DisplayDetail": "CONSUMER: This coupon can be redeemed only for the brand specified. Coupons cannot be transferred, reproduced, sold or exchanged. Any other use constitutes fraud. RETAILER: T. Marzetti will reimburse you the normal face value, plus 8? handling, provided you and the consumer have complied with the terms of this offer. Void if copied, transferred, prohibited, taxed or restricted. Customer must pay any sales tax. Any other use constitutes fraud. Cash value 1/100?. For redemption, mail to: T. Marzetti Company, CMS Dept. 70299, Mfr Rcv Office 801 Union Pacific Blvd Ste 5, Laredo TX 78045-9475. Limit: One Coupon Per Purchase.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/974/333974_86cd1c63-d27e-4657-8eab-3e181c090847.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100702000046e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7020083811,
                    7020083812,
                    7020083819,
                    7020083866,
                    7020086445,
                    7020083777
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Olive Garden Salad Dressing"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16134,
            "PromotionName": "Save $1.00 off any ONE (1) package of Quilted N (615392)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Quilted Northern",
            "StartDate": "2023-01-10T14:56:07.273",
            "EndDate": "2023-02-14T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 off any ONE (1) package of Quilted Northern Bath Tissue, 6 Mega roll or larger",
              "DisplayDetail": "Disclaimer: Consumer: LIMIT 1 COUPON PER PURCHASE. ANY OTHER USE CONSTITUTES FRAUD. Void if transferred, sold, auctioned, reproduced, altered from original, or where prohibited or restricted by law. Consumer pays sales tax. Good only in the USA, APO’s, &amp; FPO’s. Cash value .001¢. Retailer: Georgia-Pacific will reimburse you the face value of this coupon plus 8¢ if submitted in compliance with our coupon redemption policy (GP.com). Retailer must present invoices verifying stock purchases are consistent with redeemed coupons upon request. Mail to: Georgia-Pacific Consumer Products 1694, NCH Marketing Services, P.O. Box 880001, El Paso, TX 88588-0001. Georgia-Pacific Consumer Products participates in the CIC® Member Coupon Integrity Program. ©2023 Georgia-Pacific Consumer Products. All rights reserved. Unless otherwise noted, all trademarks are owned by or licensed to Georgia-Pacific Consumer Products. CIC is a trademark of Coupon Information Corporation.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/747/333747_ea9e7812-d462-47e0-9f7f-14d77295bf3c.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100420006154e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4200086527,
                    4200086532,
                    4200086785,
                    4200087125,
                    4200087128,
                    4200087133,
                    4200096166,
                    4200096402,
                    4200096365,
                    4200096367,
                    4200087206,
                    4200096702,
                    4200096700,
                    4200087250,
                    4200096896,
                    4200096897,
                    4200087281,
                    4200096928,
                    4200087363,
                    4200094255,
                    4200094265,
                    4200094283,
                    4200094421,
                    4200087442,
                    4200094443,
                    4200094425,
                    4200087444,
                    4200094429,
                    4200094431
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Quilted Northern"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16150,
            "PromotionName": "SAVE $1.00 ON TWO when you buy TWO BOXES any fl (154573)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Big G Cereals",
            "StartDate": "2023-01-10T14:56:08.24",
            "EndDate": "2023-02-16T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "SAVE $1.00 ON TWO when you buy TWO BOXES any flavor General Mills cereal listed: Cheerios™ • Cinnamon Toast Crunch™ • Lucky Charms™ • Reese’s Puffs • Chex™ • Cocoa Puffs™ • *",
              "DisplayDetail": "*Trix™ • Cookie Crisp™ • Golden Grahams™ • Kix™ • Fiber One™ • Wheaties™ • Raisin Nut Bran • Total™ • Basic 4™ • Oatmeal Crisp™ • :ratio™ (Cereal &amp; Granola pouches) • Nature Valley™ Granola (pouches). Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: General Mills will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100 cent. Send to GENERAL MILLS 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/826/333826_cbafa7ad-1e0e-4f28-9fb6-acbf14d4fa88.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100160001545e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1600027515,
                    1600027526,
                    1600027532,
                    1600027549,
                    1600027563,
                    1600027565,
                    1600027567,
                    1600027581,
                    1600027582,
                    1600027583,
                    1600043778,
                    1600043779,
                    1600048769,
                    1600048792,
                    1600048793,
                    1600048794,
                    1600048796,
                    1600048772,
                    1600043268,
                    1600043269,
                    1600049234,
                    1600012024,
                    1600012025,
                    1600012222,
                    1600012254,
                    1600012399,
                    1600012479,
                    1600012499,
                    1600012506,
                    1600012541,
                    1600012593,
                    1600012732,
                    1600014259,
                    1600012795,
                    1600014511,
                    1600012185,
                    1600010371,
                    1600015087,
                    1600015125,
                    1600015128,
                    1600015129,
                    1600015159,
                    1600015163,
                    1600015196,
                    1600015233,
                    1600014391,
                    1600015541,
                    1600015762,
                    1600015765,
                    1600015781,
                    1600015764,
                    1600016344,
                    1600016345,
                    1600016346,
                    1600016347,
                    1600016348,
                    1600016349,
                    1600016361,
                    1600016365,
                    1600016366,
                    1600016367,
                    1600012495,
                    1600016254,
                    1600016167,
                    1600016764,
                    1600016849,
                    1600016967,
                    1600016968,
                    1600016969,
                    1600017113,
                    1600017125,
                    1600017283,
                    1600017284,
                    1600017318,
                    1600017923,
                    1600016875,
                    1600017003,
                    1600018459,
                    1600018486,
                    1600018517,
                    1600018587,
                    1600017102,
                    1600018433,
                    1600018456,
                    1600018457,
                    1600019133,
                    1600018675,
                    1600018875,
                    1600018884
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Big G Cereals"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16156,
            "PromotionName": "Save $1.50 on Any ONE (1) Finish® Dishwasher De (203095)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Finish Dishwasher",
            "StartDate": "2023-01-10T14:56:08.477",
            "EndDate": "2023-02-13T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-01-16T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 150,
              "DisplaySummary": "Save $1.50 on Any ONE (1) Finish® Dishwasher Detergent (Quantum® or Power®), JET-DRY® Rinse Aid, or Dishwasher Cleaner",
              "DisplayDetail": "Consumer and Retailer: LIMIT ONE (1) COUPON PER PURCHASE OF SPECIFIED PRODUCT AND QUANTITY STATED. NOT TO BE COMBINED WITH ANY OTHER COUPON(S). LIMIT OF TWO (2) LIKE COUPONS IN SAME SHOPPING TRIP. VOID IF REPRODUCED, PURCHASED, TRADED OR SOLD. ANY OTHER USE CONSTITUTES FRAUD. Consumer: You pay any sales tax. Retailer: You are authorized to act as our agent and redeem this coupon in acceptance with RB Coupon Redemption Policy: face value plus 8¢. Send coupons to: Reckitt Benckiser LLC. Inmar Brand Solutions Dept. 26600, Mfr Rcv Office, 801 Union Pacific Blvd STE 5, Laredo, TX 78045-9475. Cash value 1/100 of 1¢. Good only in the U.S.A. Void where prohibited. © 2023 Reckitt Benckiser LLC",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/660/333660_8a5809b3-64c9-4c05-ac0c-2c86301345e5.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100517002031e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    5170036930,
                    5170075683,
                    5170076631,
                    5170077039,
                    5170077050,
                    5170078826,
                    5170080312,
                    5170081049,
                    5170081050,
                    5170081687,
                    5170081688,
                    5170089629,
                    5170089712,
                    5170089713,
                    5170089715,
                    5170089716,
                    5170089958,
                    5170085272,
                    5170092787,
                    5170092788,
                    5170092763,
                    5170092789,
                    5170095315,
                    5170081689,
                    5170092766,
                    5170093269,
                    5170098304,
                    5170098306,
                    5170098307,
                    5170098820,
                    5170020605,
                    5170020623,
                    5170020614,
                    5170020606,
                    5170020613,
                    5170020615,
                    5170020640,
                    5170099662
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Finish® Dishwasher Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16157,
            "PromotionName": "SAVE $1.00 on any ONE (1) Natures Bounty® Vitam (302755)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Natures Bounty",
            "StartDate": "2023-01-10T14:56:08.553",
            "EndDate": "2023-03-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-08T03:01:00",
              "DisplayEndDate": "2023-02-06T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "SAVE $1.00 on any ONE (1) Nature's Bounty® Vitamin or Supplement",
              "DisplayDetail": "Consumer: This coupon is good only on the purchase of product indicated. Any other use constitutes fraud. Limit one coupon per purchase per customer. Consumer pays any sales tax. Void if copied, transferred, prohibited, taxed or restricted. Good only in U.S.A., including U.S. Military Bases. Retailer: For payment of face value, plus 8¢ handling, send to The Nature’s Bounty Co. #1664, PO Box 880001, El Paso, TX 88588-0001. Coupon will be paid only if presented by an authorized retailer of our merchandise. Cash redemption value of 1/100 of one cent.   *Some statements have not been evaluated by the Food &amp; Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/810/333810_46da4756-1078-42de-a7f7-c7adc1207d4e.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100743123028e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7431207580,
                    7431236809,
                    7431236812,
                    7431250872,
                    7431251109,
                    7431205145,
                    7431233511,
                    7431235710,
                    7431253545,
                    7431255366,
                    7431255367,
                    7431255368,
                    7431264787,
                    7431264821,
                    7431265272,
                    7431280115,
                    7431280116,
                    7431278572,
                    7431278574
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Nature's Bounty®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16159,
            "PromotionName": "SAVE 50¢ ON TWO when you buy TWO BOXES any flav (154785)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Nature Valley",
            "StartDate": "2023-01-10T14:56:08.647",
            "EndDate": "2023-02-16T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "SAVE 50¢ ON TWO when you buy TWO BOXES any flavor/variety 4 COUNT OR LARGER Nature Valley™ Granola Bars, Protein Bars, Biscuits, Cups, Wafers, Soft-Baked Squares, Soft-Baked *",
              "DisplayDetail": "*Muffins OR Crunchy Dipped Granola Squares. Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: General Mills will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100 cent. Send to GENERAL MILLS 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/766/333766_e7b72365-5cfb-4d77-9c63-6da29ebd0150.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100160001547e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1600016893,
                    1600016894,
                    1600026460,
                    1600026470,
                    1600027706,
                    1600027707,
                    1600028415,
                    1600028920,
                    1600029570,
                    1600029860,
                    1600043101,
                    1600043102,
                    1600043980,
                    1600026590,
                    1600027855,
                    1600028372,
                    1600040761,
                    1600041314,
                    1600045723,
                    1600045724,
                    1600041126,
                    1600041269,
                    1600045798,
                    1600045897,
                    1600045898,
                    1600048287,
                    1600041727,
                    1600048542,
                    1600044486,
                    1600046679,
                    1600046684,
                    1600047296,
                    1600048982,
                    1600048983,
                    1600049392,
                    1600014097,
                    1600014943,
                    1600014945,
                    1600015873,
                    1600015874,
                    1600015898,
                    1600045891,
                    1600047779,
                    1600049554,
                    1600017939,
                    1600017941,
                    1600017944,
                    1600018793,
                    1600018794,
                    1600018795,
                    1600018892
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Nature Valley™"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16160,
            "PromotionName": "Save $0.50 on Any ONE (1) Lysol® Product (exclu (203098)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Lysol",
            "StartDate": "2023-01-10T14:56:08.727",
            "EndDate": "2023-02-13T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-01-16T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 50,
              "DisplaySummary": "Save $0.50 on Any ONE (1) Lysol® Product (excluding trial and travel sizes)",
              "DisplayDetail": "LIMIT ONE (1) COUPON PER PURCHASE OF SPECIFIED PRODUCT AND QUANTITY STATED. NOT TO BE COMBINED WITH ANY OTHER COUPON(S). LIMIT OF TWO (2) LIKE COUPONS IN SAME SHOPPING TRIP. VOID IF REPRODUCED, PURCHASED, TRADED OR SOLD. ANY OTHER USE CONSTITUTES FRAUD. Consumer: You pay any sales tax. Retailer: You are authorized to act as our agent and redeem this coupon in acceptance with RB Coupon Redemption Policy: face value plus 8¢. Send coupons to: Reckitt Benckiser LLC. Inmar Brand Solutions Dept. 26600, Mfr Rcv Office, 801 Union Pacific Blvd STE 5, Laredo, TX 78045-9475. Cash value 1/100 of 1¢. Good only in the U.S.A. Void where prohibited. © 2023 Reckitt Benckiser LLC",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/771/333771_7040597c-2998-41a1-9666-974200b9fe19.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100192002031e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1920000888,
                    1920002201,
                    1920002291,
                    1920002522,
                    1920002569,
                    1920002699,
                    1920002845,
                    1920002922,
                    1920074185,
                    1920074186,
                    1920075055,
                    1920075352,
                    1920076878,
                    1920076938,
                    1920076940,
                    1920077182,
                    1920077660,
                    1920078625,
                    1920078626,
                    1920078630,
                    1920078849,
                    1920078914,
                    1920079326,
                    1920079328,
                    1920079329,
                    1920079481,
                    1920079830,
                    1920079831,
                    1920000061,
                    1920000062,
                    1920000066,
                    1920000785,
                    1920000786,
                    1920078862,
                    1920080088,
                    1920080881,
                    1920080912,
                    1920081143,
                    1920081145,
                    1920081700,
                    1920082669,
                    1920082670,
                    1920083721,
                    1920083853,
                    1920000310,
                    1920000311,
                    1920079174,
                    1920080296,
                    1920080834,
                    1920085097,
                    1920085018,
                    1920085020,
                    1920085668,
                    1920088209,
                    1920000316,
                    1920000317,
                    1920000318,
                    1920000319,
                    1920000320,
                    1920087871,
                    1920089106,
                    1920089341,
                    1920087870,
                    1920092921,
                    1920092993,
                    1920093205,
                    1920094121,
                    1920094122,
                    1920082159,
                    1920095871,
                    1920095872,
                    1920098359,
                    1920096207,
                    1920097181,
                    1920098772,
                    1920099100,
                    1920099118,
                    1920098019,
                    1920099716,
                    1920049128
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Lysol®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16176,
            "PromotionName": "$5.00 OFF on any ONE (1) Osteo Bi-Flex® product (302709)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Osteo Bi-Flex",
            "StartDate": "2023-01-10T14:56:09.49",
            "EndDate": "2023-02-21T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-01-31T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 500,
              "DisplaySummary": "$5.00 OFF on any ONE (1) Osteo Bi-Flex® product",
              "DisplayDetail": "Consumer: This coupon good only on the purchase of product indicated. Any other use constitutes fraud. Limit one coupon per purchase per customer. Consumer pays any sales tax. Void if copied, transferred, prohibited, taxed or restricted. Good only in U.S.A., including U.S. Military Bases. Retailer: For payment of face value, plus 8¢ handling, send to The Nature’s Bounty Co. #1664, PO Box 880001, El Paso, TX 88588-0001. Coupon will be paid only if presented by an authorized retailer of our merchandise. Cash redemption value of 1/100 of one cent. EXPIRES: 2/19/2023.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/685/333685_fa814793-3a54-4811-b266-18c23d6df7d4.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307683027e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3076801748,
                    3076803120,
                    3076803121,
                    3076803134,
                    3076803137,
                    3076803138,
                    3076803139,
                    3076803452,
                    3076815471,
                    3076803136,
                    3076818870,
                    3076852876,
                    3076819608,
                    3076833049,
                    3076819607,
                    3076854127,
                    3076867930
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Osteo Bi-Flex®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16177,
            "PromotionName": "SAVE $1.00 ON FOUR when you buy FOUR CUPS any f (154658)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": ":ratio",
            "StartDate": "2023-01-10T14:56:09.52",
            "EndDate": "2023-02-16T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "SAVE $1.00 ON FOUR when you buy FOUR CUPS any flavor/variety :ratio™ PROTEIN or KETO* Friendly Dairy Snack",
              "DisplayDetail": "SEE NUTRITION INFORMATION FOR CALORIES, TOTAL FAT AND SAT. FAT CONTENT. *Always consult your physician before starting an eating plan that involves regular consumption of high fat foods Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: General Mills will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100 cent. Send to GENERAL MILLS 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/828/333828_04d180b3-815e-40bb-9172-bce87e9872ea.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100704701546e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 4,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7047016473,
                    7047016592,
                    7047016593,
                    7047016594,
                    7047016595,
                    7047016485,
                    7047016486,
                    7047016487,
                    7047018507,
                    7047018511,
                    7047018512,
                    7047018709,
                    7047018711,
                    7047018712
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": ":ratio™"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16178,
            "PromotionName": "SAVE $2.00 Off ONE (1) vitafusion™ or Lil Critt (020263)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "vitafusion or Lil",
            "StartDate": "2023-01-10T14:56:09.583",
            "EndDate": "2023-02-13T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 200,
              "DisplaySummary": "SAVE $2.00 Off ONE (1) vitafusion™ or L'il Critters™",
              "DisplayDetail": "Valid only for product, size stated up to the value stated. Limit one coupon per purchase. Consumer must pay sales tax. RETAILER: Only US retail distributors of product stated or others as specifically authorized by us may redeem coupon for face value plus 8¢ handling if terms of offer are met. Upon request, retailer must show invoices for enough stock to cover coupons presented. Cash value 1/100¢. Mail to: Inmar Brand Solutions Dept. #33200, Mfr Rcv Office, 801 Union Pacific Blvd STE 5, Laredo, TX 78045-9475. Void where prohibited, taxed, licensed, or restricted; or if copied, altered, or transferred. Church &amp; Dwight Co., Inc is a part of the CIC® Member Coupon Integrity Program",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/744/333744_417006d2-0209-4971-a1e7-b6ec36733779.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100279170202e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    2791700603,
                    2791700623,
                    2791701426,
                    2791701468,
                    2791701629,
                    2791702076,
                    2791701950,
                    2791702270,
                    2791702271,
                    2791701417,
                    2791701919,
                    2791701920,
                    2791701945,
                    2791701951,
                    2791702133,
                    2791702310,
                    2791727111,
                    2791701890,
                    2791701893,
                    2791702005,
                    2791702134,
                    2791702671,
                    2791727097,
                    2791700025,
                    2791727165,
                    2791727166,
                    2791727167,
                    2791727169,
                    2791727168,
                    2791700386,
                    2791726005,
                    2791727173
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "vitafusion™ or L'il Critters™"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16179,
            "PromotionName": "Save $1.00 off any ONE (1) package of Brawny® P (615475)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Brawny",
            "StartDate": "2023-01-10T14:56:09.63",
            "EndDate": "2023-02-14T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 off any ONE (1) package of Brawny® Paper Towels, 4 Roll or larger",
              "DisplayDetail": "Consumer:  LIMIT 1 COUPON PER PURCHASE.  ANY OTHER USE CONSTITUTES FRAUD.  Void if transferred, sold, auctioned, reproduced, altered from original, or where prohibited or restricted by law. Consumer pays sales tax.  Good only in the USA, APO’s, &amp; FPO’s. Cash value .001¢.  Retailer:  Georgia-Pacific will reimburse you the face value of this coupon plus 8¢ if submitted in compliance with our coupon redemption policy (available at GP.com). Retailer must present invoices verifying stock purchases are consistent with redeemed coupons upon request. No cash or credit in excess of shelf price may be returned to consumer or applied to transaction. Mail to:Georgia-Pacific Consumer Products 1694, NCH Marketing Services, P.O. Box 880001, El Paso, TX 88588-0001. Georgia-Pacific Consumer Products participates in the CIC® Member Coupon Integrity Program. ©2023 Georgia-Pacific Consumer Products. All rights reserved. Unless otherwise noted, all trademarks are owned by or licensed to Georgia-Pacific Consumer Products.  CIC is a trademark of Coupon Information Corporation.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/34/010/334010_04ce3e97-f98f-4bb0-8e54-d707e32a42d5.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100420006155e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4200044517,
                    4200044886,
                    4200043910,
                    4200043913,
                    4200043916,
                    4200044078,
                    4200044080,
                    4200044133,
                    4200044143,
                    4200044192,
                    4200044196,
                    4200044213,
                    4200044276,
                    4200044356
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Brawny"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16180,
            "PromotionName": "SAVE $1.00 ON ONE when you buy ONE BOX any flav (154747)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "LRABAR, EPIC, :rat",
            "StartDate": "2023-01-10T14:56:09.66",
            "EndDate": "2023-02-16T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "SAVE $1.00 ON ONE when you buy ONE BOX any flavor/variety 4 COUNT OR LARGER LÄRABAR™ Bars, EPIC™ Bars OR :ratio™ KETO* Friendly Bars",
              "DisplayDetail": "SEE NUTRITION INFORMATION FOR CALORIES, TOTAL FAT AND SAT. FAT CONTENT. *Always consult your physician before starting an eating plan that involves regular consumption of high fat foods Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: Small Planet Foods will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100¢. Small Planet Foods 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/765/333765_cd9dc95e-7772-4cfe-bc81-3c3834d86904.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100219081547e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    2190811532,
                    2190811535,
                    2190811536,
                    2190811539,
                    2190811546,
                    1600016434,
                    1600016435,
                    1600017352,
                    1600017362,
                    2190811541,
                    1600017989,
                    1600017991
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "LÄRABAR™, EPIC™, :ratio™"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16196,
            "PromotionName": "$1.00 OFF any ONE (1) package of Angel Soft® Ba (615395)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Angel Soft",
            "StartDate": "2023-01-10T14:56:10.473",
            "EndDate": "2023-02-14T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-13T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "$1.00 OFF any ONE (1) package of Angel Soft® Bath Tissue, 8 Mega roll or larger",
              "DisplayDetail": "Consumer:  LIMIT 1 COUPON PER PURCHASE.  ANY OTHER USE CONSTITUTES FRAUD.  Void if transferred, sold, auctioned, reproduced, altered from original, or where prohibited or restricted by law. Consumer pays sales tax.  Good only in the USA, APO’s, &amp; FPO’s. Cash value .001¢.  Retailer:  Georgia-Pacific will reimburse you the face value of this coupon plus 8¢ if submitted in compliance with our coupon redemption policy (GP.com). Retailer must present invoices verifying stock purchases are consistent with redeemed coupons upon request. Mail to: Georgia-Pacific Consumer Products 1694, NCH Marketing Services, P.O. Box 880001, El Paso, TX 88588-0001. Georgia-Pacific Consumer Products participates in the CIC® Member Coupon Integrity Program. ©2023 Georgia-Pacific Consumer Products. All rights reserved. Unless otherwise noted, all trademarks are owned by or licensed to Georgia-Pacific Consumer Products.  CIC is a trademark of Coupon Information Corporation.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/725/333725_df939649-b38c-4fef-a884-9d0cf65f0e5f.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100304006154e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3040077171,
                    3040077216,
                    3040077377,
                    3040077585,
                    3040077366,
                    3040077133,
                    3040077355,
                    3040077569,
                    3040078949,
                    3040079020,
                    3040079051,
                    3040079115,
                    3040079170,
                    3040079176,
                    3040079178,
                    3040079217,
                    3040079226,
                    3040079258,
                    3040079207,
                    3040079211,
                    3040079265
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Angel Soft®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16202,
            "PromotionName": "Save $0.35 on one (1) pack of Wonder® Classic L (010193)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Wonder",
            "StartDate": "2023-01-10T14:56:10.707",
            "EndDate": "2023-02-07T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-02T03:01:00",
              "DisplayEndDate": "2023-01-24T02:58:59.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 35,
              "DisplaySummary": "Save $0.35 on one (1) pack of Wonder® Classic Loaf Breads, 20oz and 24oz",
              "DisplayDetail": "Consumer: Only one coupon per purchase.  You pay sales tax and/or deposit charge.  Coupon may not be assigned, transferred, purchased, sold or reproduced.  Any other use constitutes fraud.  Cash Value 1/100 of 1¢.RETAILER: We will reimburse you for the face value of the coupon, plus 8¢ handling allowance, if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address.  Mail coupons to: Inmar Dept #72250, Mfr Rcv Office, 801 Union Pacific Blvd. Suite 5, Laredo, TX 78045-9475.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/776/333776_fea4ba0a-3974-4588-9d36-1ef7c73a9b9e.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100722500102e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7225001137,
                    7225001138
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Wonder®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16204,
            "PromotionName": "SAVE $5.00 On any TWO (2) Ensure® Multipacks (047354)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Ensure",
            "StartDate": "2023-01-10T14:56:10.8",
            "EndDate": "2023-02-20T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-08T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 500,
              "DisplaySummary": "SAVE $5.00 On any TWO (2) Ensure® Multipacks",
              "DisplayDetail": "Consumer and Retailer: LIMIT 1 COUPON PER PURCHASE PER PRODUCT SPECIFIED AND QUANTITY STATED. Cannot be combined with other offers. LIMIT OF TWO (2) IDENTICAL COUPONS IN SAME SHOPPING TRIP. Void if expired, altered, reproduced, copied, sold, transferred, taxed, restricted, exchanged to any person, firm, or group prior to store redemption, or prohibited by law. Any other use constitutes fraud. Good only in USA and territories. Cash value 1/100¢. Consumer pays sales tax. Retailer/Clearinghouse: By submitting, you agree to Abbott’s Coupon Redemption Policy (available upon request). Abbott will reimburse you face value of coupon (or actual retail price of item if less) plus 8¢ handling. Send to Inmar Brand Solutions Dept. 70074, Mfr Rcv Office, 801 Union Pacific Blvd Ste 5, Laredo, TX 78045-9475. Pharmacists/Retailers: Coupon not valid for product reimbursed, in whole or part, under Medicare, Medicaid or similar federal or state government programs. Abbott Nutrition participates in the CIC® Member Coupon Integrity Program.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/945/333945_5b7af7da-2c2b-41ce-bf3f-4662fcf95b39.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100700740473e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7007440701,
                    7007440702,
                    7007440705,
                    7007440707,
                    7007440711,
                    7007440718,
                    7007451785,
                    7007456016,
                    7007460750,
                    7007453807,
                    7007453810,
                    7007462481,
                    7007456501,
                    7007464116,
                    7007464118,
                    7007464122,
                    7007464124,
                    7007464292,
                    7007464294,
                    7007464297,
                    7007453432,
                    7007466891,
                    7007466897,
                    7007466911,
                    7007467166,
                    7007453623
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Ensure®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16213,
            "PromotionName": "Save $1.75 On Any ONE (1) Air Wick® Product (ex (203091)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Air Wick",
            "StartDate": "2023-01-10T14:56:11.673",
            "EndDate": "2023-02-13T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-01-16T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 175,
              "DisplaySummary": "Save $1.75 On Any ONE (1) Air Wick® Product (excludes 8oz Aerosols)",
              "DisplayDetail": "Consumer and Retailer: LIMIT ONE (1) COUPON PER PURCHASE OF SPECIFIED PRODUCT AND QUANTITY STATED. NOT TO BE COMBINED WITH ANY OTHER COUPON(S). LIMIT OF TWO (2) LIKE COUPONS IN SAME SHOPPING TRIP. VOID IF REPRODUCED, PURCHASED, TRADED OR SOLD. ANY OTHER USE CONSTITUTES FRAUD. Consumer: You pay any sales tax. Retailer: You are authorized to act as our agent and redeem this coupon in acceptance with RB Coupon Redemption Policy: face value plus 8¢. Send coupons to: Reckitt Benckiser LLC. Inmar Brand Solutions Dept. 26600, Mfr Rcv Office, 801 Union Pacific Blvd STE 5, Laredo, TX 78045-9475. Cash value 1/100 of 1¢. Good only in the U.S.A. Void where prohibited. © 2023 Reckitt Benckiser LLC",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/966/333966_0751c0c5-047c-4e1e-a529-7f8e7c9bbf98.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100623382031e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    6233877397,
                    6233877960,
                    6233877961,
                    6233877964,
                    6233878046,
                    6233878048,
                    6233878283,
                    6233878473,
                    6233879553,
                    6233879717,
                    6233879782,
                    6233880095,
                    6233880978,
                    6233882291,
                    6233882314,
                    6233880420,
                    6233885191,
                    6233885175,
                    6233889748,
                    6233891097,
                    6233891101,
                    6233891108,
                    6233891112,
                    6233892944,
                    6233881465,
                    6233882093,
                    6233883350,
                    6233884473,
                    6233891110,
                    6233895476,
                    6233897052,
                    6233897053,
                    6233885723,
                    6233898552,
                    6233898553,
                    6233898554,
                    6233898577,
                    6233898317,
                    6233898322,
                    6233898327,
                    6233898332,
                    6233898337,
                    6233899615,
                    6233800623,
                    6233877914,
                    6233899665,
                    6233889666,
                    6233896897,
                    6233898260,
                    6233898325,
                    6233898576
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Air Wick®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16214,
            "PromotionName": "SAVE 50¢ ON TWO when you buy TWO BOXES any flav (154768)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Fiber One/Protein",
            "StartDate": "2023-01-10T14:56:11.703",
            "EndDate": "2023-02-16T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "SAVE 50¢ ON TWO when you buy TWO BOXES any flavor/variety Fiber One™ OR Protein One snack product",
              "DisplayDetail": "Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: General Mills will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100 cent. Send to GENERAL MILLS 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/769/333769_ed28e544-19b9-4e95-a4a8-b0fa20cba3be.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100160001547e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1600014344,
                    1600026164,
                    1600026165,
                    1600028166,
                    1600042025,
                    1600042371,
                    1600041544,
                    1600042641,
                    1600044216,
                    1600041149,
                    1600045682,
                    1600045696,
                    1600045701,
                    1600048035,
                    1600048037,
                    1600044512,
                    1600043976,
                    1600010781,
                    1600010783,
                    1600014085,
                    1600014086,
                    1600014089,
                    1600014091,
                    1600014525
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Fiber One™/Protein One"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16228,
            "PromotionName": "SAVE $3.00 On any ONE (1) Colgate® Optic White® (055349)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Colgate Toothpaste",
            "StartDate": "2023-01-10T14:56:12.343",
            "EndDate": "2023-02-02T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-02-02T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "SAVE $3.00 On any ONE (1) Colgate® Optic White® Pro Series, Optic White® Renewal, Total® Plaque Pro-Release, Gum Renewal or Enamel Renewal Toothpaste",
              "DisplayDetail": "CONSUMER: LIMIT ONE (1) COUPON PER PURCHASE OF PRODUCT &amp; QUANTITY STATED. No more than two (2) identical coupons for same product in same day. Do not send this coupon to Colgate-Palmolive. Void if transferred, sold, auctioned, reproduced or altered from original. You must pay any sales tax. RETAILER: Colgate-Palmolive will reimburse the face value plus up to 10.5¢ handling if submitted in accordance with our Redemption Policy. For policy and/or coupon redemption send to: Colgate-Palmolive 1119, P.O. Box 880001, El Paso, TX 88588-0001. Cash Value 1/100¢. No cash or credit in excess of shelf price may be returned to consumer or applied to transaction. Coupon may not be bought, reproduced, transferred or sold. Void where prohibited or if transferred to any person, firm or group prior to store redemption. Valid only in the USA (not in Puerto Rico). Redeemable at Food, Drug, Discount &amp; other stores accepting coupons. Colgate-Palmolive participates in the CIC® member Coupon Integrity Program.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/985/333985_bb9177b5-3014-4e21-bf70-661e59b45ad6.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100350000553e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3500046977,
                    3500097008
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Colgate® Toothpaste"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16230,
            "PromotionName": "$1.50 OFF TWO (2) ZonePerfect® Bar Multi-packs  (047368)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "ZonePerfect",
            "StartDate": "2023-01-10T14:56:12.437",
            "EndDate": "2023-02-07T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-01T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 150,
              "DisplaySummary": "$1.50 OFF TWO (2) ZonePerfect® Bar Multi-packs (5ct, 6ct, 10ct or 12ct cartons)",
              "DisplayDetail": "Consumer and Retailer: LIMIT 1 COUPON PER PURCHASE PER PRODUCT SPECIFIED AND QUANTITY STATED. Cannot be combined with other offers. LIMIT OF TWO (2) IDENTICAL COUPONS IN SAME SHOPPING TRIP. Void if expired, altered, reproduced, copied, sold, transferred, taxed, restricted, exchanged to any person, firm, or group prior to store redemption, or prohibited by law. Any other use constitutes fraud.  Good only in USA and territories. Cash value 1/100¢. Consumer pays sales tax. Retailer/Clearinghouse: By submitting, you agree to Abbott’s Coupon Redemption Policy (available upon request). Abbott will reimburse you face value of coupon (or actual retail price of item if less) plus 8¢ handling. Send to Inmar Brand Solutions Dept. 70074, Mfr Rcv Office, 801 Union Pacific Blvd Ste 5, Laredo, TX 78045-9475. Pharmacists/Retailers: Coupon not valid for product reimbursed, in whole or part, under Medicare, Medicaid or similar federal or state government programs. Abbott Nutrition participates in the CIC® Member Coupon Integrity Program.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/683/333683_3865159a-7158-4c6b-b563-526bd927f037.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110106381020474e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    63810220472,
                    63810220473,
                    63810220474,
                    63810220475,
                    63810220476,
                    63810253291,
                    63810253293,
                    63810253842,
                    63810256136,
                    63810256693,
                    63810263510,
                    63810266210,
                    63810266218,
                    63810266412,
                    63810266420,
                    63810266426,
                    63810267890
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "ZonePerfect®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16232,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83200",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "",
            "StartDate": "2022-01-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16234,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83209",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scouts",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16235,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83210",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scout",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16236,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83211",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scout",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16237,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83212",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scout",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16238,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83213",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scout",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16239,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83214",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scout",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16240,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83215",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scout",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16241,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83216",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scout",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16242,
            "PromotionName": "Advertising - Boy Scout 2023 Test 83217",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Boy Scout",
            "StartDate": "2022-12-07T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "AnonymousDistribution": {
              "Type": "AllTransactions"
            },
            "TransactionLimit": 1,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 500
            },
            "TransactionQualificationCriteria": {
              "Threshold": 5000
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16245,
            "PromotionName": "SAVE $3.00 on ONE (1) 3 lb or larger bag of Bey (220069)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Beyond Dry Cat Foo",
            "StartDate": "2023-01-13T03:16:04.807",
            "EndDate": "2023-02-21T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-13T03:01:00",
              "DisplayEndDate": "2023-02-11T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "SAVE $3.00 on ONE (1) 3 lb or larger bag of Beyond® Dry Cat Food",
              "DisplayDetail": "NOT FOR RESALE. Coupon void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. CIC® Member Coupon Integrity Program. CONSUMER: Limit one coupon per specified item(s) purchased. No cash or credit in excess of shelf price awarded. Any other use constitutes fraud. RETAILER: Nestlé Purina PetCare Company, Inmar Dept. #17800, 801 Union Pacific Blvd, STE 5, Laredo, TX 78045, USA will redeem this coupon per the Nestlé Coupon Redemption Policy found at http://www.purina.com/terms-and-conditions. Consumer must pay sales tax where applicable. Valid in the USA, incl. APOs/FPOs/Possessions/Territories. Cash value: 1/80?.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/919/333919_1c7595a4-07e0-401b-bd4b-8bcb2a42f68b.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100178002201e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1780016362,
                    1780016364,
                    1780016373,
                    1780016379,
                    1780016383,
                    1780016385,
                    1780016387,
                    1780016408,
                    1780017069
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Pet Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Beyond® Dry Cat Food"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16246,
            "PromotionName": "SAVE 50¢ ON TWO when you buy TWO BOXES of Annie (156871)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Annies",
            "StartDate": "2023-01-15T03:16:21.667",
            "EndDate": "2023-03-03T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:01:00",
              "DisplayEndDate": "2023-02-17T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "SAVE 50¢ ON TWO when you buy TWO BOXES of Annie's™ Mac &amp; Cheese (excludes Deluxe, cups, multipacks, and frozen)",
              "DisplayDetail": "Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: Annie's will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100 cent. Send to ANNIE'S 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/710/333710_2b3fbc7a-8c6f-4f4e-96b0-7d34f47fb39c.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100135621569e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1356200004,
                    1356230060,
                    1356230062,
                    1356230069,
                    1356230084,
                    1356230088,
                    1356230097,
                    1356230098,
                    1356200045
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Annie's™"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16249,
            "PromotionName": "Save $3.00 ONE Gain Liquid Fabric Softener 164  (178637)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gain Fireworks Fab",
            "StartDate": "2023-01-15T03:16:21.713",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Gain Liquid Fabric Softener 164 oz OR Gain Fireworks In-Wash Scent Boosters 20.1- 26.5 oz (excludes Gain Flings, Gain Liquid/Powder Laundry Detergent, Gain Essential Oils, Gain Ultra Flings, Gain Sheets and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/794/333794_c5cc8d38-00d1-460a-9e11-327844ddfb68.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721786e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700076362,
                    3077200305
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gain Fireworks Fabric Enhancer"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16250,
            "PromotionName": "Save $3.00 on any ONE (1) Flintstones™ or One A (023343)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Flintstones or One",
            "StartDate": "2023-01-15T03:16:21.727",
            "EndDate": "2023-02-13T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 on any ONE (1) Flintstones™ or One A Day® Kids product 60 count or larger",
              "DisplayDetail": "CONSUMER: LIMIT ONE COUPON PER PURCHASE on specified product(s), size(s) and quantity stated. LIMIT OF 4 EXACT SAME COUPONS PER HOUSEHOLD PER DAY. You pay any sales tax. Void if copied, sold, transferred, altered, or auctioned. RETAILER: You are authorized to act as our agent and redeem this coupon at face value on the specified product(s). We will reimburse you for the face value of this coupon plus 8¢ if submitted in compliance with the Bayer HealthCare LLC Coupon Redemption Policy, incorporated herein by reference. USE NOT CONSISTENT WITH THESE TERMS MAY CONSTITUTE FRAUD AND MAY VOID ALL COUPONS SUBMITTED. Send coupons to: Bayer HealthCare LLC 1355, P.O. Box 880001, El Paso, TX 88588-0001. Cash Value, 1/20th of 1¢. Good only in the U.S.A.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/933/333933_9f053c36-1e25-417e-b0ba-0806d21bfd06.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100165000233e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1650007909,
                    1650008619,
                    1650008806,
                    1650009713,
                    1650053082,
                    1650053728,
                    1650054830,
                    1650055389,
                    1650055434,
                    1650055435,
                    1650055436,
                    1650055437,
                    1650059331,
                    1650056862
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Flintstones™ or One A Day® Kids"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16254,
            "PromotionName": "SAVE 50¢ ON TWO when you buy TWO PACKAGES of an (156849)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Annies",
            "StartDate": "2023-01-15T03:16:21.867",
            "EndDate": "2023-03-03T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:01:00",
              "DisplayEndDate": "2023-02-17T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "SAVE 50¢ ON TWO when you buy TWO PACKAGES of any variety Annie's™ Snacks (Includes Fruit Snacks, Cookies, Crackers, Grahams, Snack Bars, Snack Mix, OR Cheese Puffs)",
              "DisplayDetail": "Void if altered, copied, sold, purchased, transferred, exchanged or where prohibited or restricted by law. One coupon per purchase of specified product(s). Good only in USA, APOs &amp; FPOs. CONSUMER: No other coupon may be used with this coupon. Consumer pays any sales tax. RETAILER: Annie's will reimburse you the face value of this coupon plus handling if submitted in compliance with our redemption policy. Copy available upon request. Cash value 1/100 cent. Send to ANNIE'S 8, NCH Marketing Services, P.O. Box 880001, El Paso TX 88588-0001 or an authorized clearinghouse.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/941/333941_3fc9d8e2-910e-491c-b364-8a557eadab25.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100135621569e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1356230215,
                    1356200015,
                    1356200017,
                    1356211100,
                    1356211105,
                    1356211107,
                    1356230055,
                    1356230057,
                    1356230228,
                    1356230261,
                    1356200051,
                    1356200052,
                    1356200053,
                    1356200260,
                    1356200262,
                    1356200126,
                    1356200241,
                    1356228972,
                    1356249658,
                    1356210923,
                    1356211492,
                    1356200018,
                    1356200156,
                    1356200242
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Annie's™"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16255,
            "PromotionName": "Save $2.00 on any ONE (1) Clorox® Disinfecting  (075100)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Clorox Disinfectin",
            "StartDate": "2023-01-15T03:16:21.867",
            "EndDate": "2023-02-13T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 on any ONE (1) Clorox® Disinfecting Mist, 10oz+",
              "DisplayDetail": "CONSUMER: LIMIT ONE COUPON PER PURCHASE of products and quantities stated. LIMIT OF 4 IDENTICAL COUPONS PER HOUSEHOLD PER DAY. Coupons not authorized if purchasing products for resale. Only original coupons accepted. Copying, selling, reposting or auctioning of coupons is prohibited and constitutes fraud. Overage will not be provided in exchange for any coupons (i.e., NO CASH BACK). You pay sales tax. Valid in USA, APOs and FPOs only. Void where taxed, restricted or prohibited. RETAILER: You are authorized to act as our agent to redeem this coupon in accordance with The Clorox Sales Company coupon redemption policy (available upon request). We will reimburse you for face value plus up to $0.12 handling if submitted in accordance with our redemption policy. Send coupons to: The Clorox Company 2122, NCH Marketing Services, P.O. Box 880001, El Paso, TX 88588-0001. The Clorox Company participates in the CIC® Member Coupon Integrity Program.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/939/333939_ddaa9be1-52e4-4724-9f2e-8006b82196e9.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100446000751e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4460060151,
                    4460060152,
                    4460060155,
                    4460060156
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Clorox® Disinfecting Mist"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16256,
            "PromotionName": "Save $1.00 ONE Tide Simply Laundry Detergent 50 (178646)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Simply Laundr",
            "StartDate": "2023-01-15T03:16:21.9",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Tide Simply Laundry Detergent 50 oz or larger OR ERA Laundry Detergent 75 oz or larger (excludes Tide Simply PODS, Downy Libre Enjuague, Bounce/Downy WrinkleGuard, Bounce Pet Hair &amp; Lint Guard, Gain Fireworks, Tide Detergent, Tide PODS and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/34/003/334003_3624b6ae-ba24-4fc7-9102-f24641414d37.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001786e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700089120,
                    3700089121,
                    3700089130,
                    3700089131,
                    3700098161,
                    3700089010,
                    3700044190,
                    3700044311,
                    3700044798,
                    3700044800,
                    3700045183
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Simply Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16259,
            "PromotionName": "Save $3.00 ONE Gain Flings Laundry Detergent 42 (178638)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gain Flings Laundr",
            "StartDate": "2023-01-15T03:16:21.96",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Gain Flings Laundry Detergent 42 ct -96 ct (excludes Gain Liquid/Powder Laundry Detergent, Gain Essential Oils, Gain Liquid Fabric Softeners, Gain Fireworks, Gain Sheets, Gain Flings 9 ct and below and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/34/007/334007_5dc22ec4-4be9-4e93-9afd-d16f9ad93ff1.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001786e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700091792,
                    3700079168,
                    3700079225,
                    3700079167,
                    3700086204,
                    3700091796,
                    3700086202,
                    3077202440,
                    3077202441,
                    3700048848,
                    3700048853
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gain Flings Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16261,
            "PromotionName": "Save $0.50 on Any ONE (1) Lysol® Disinfecting W (203100)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Lysol",
            "StartDate": "2023-01-15T03:16:22.023",
            "EndDate": "2023-02-27T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 50,
              "DisplaySummary": "Save $0.50 on Any ONE (1) Lysol® Disinfecting Wipes (30 ct. or Higher)",
              "DisplayDetail": "LIMIT ONE (1) COUPON PER PURCHASE OF SPECIFIED PRODUCT AND QUANTITY STATED. NOT TO BE COMBINED WITH ANY OTHER COUPON(S). LIMIT OF TWO (2) LIKE COUPONS IN SAME SHOPPING TRIP. VOID IF REPRODUCED, PURCHASED, TRADED OR SOLD. ANY OTHER USE CONSTITUTES FRAUD. Consumer: You pay any sales tax. Retailer: You are authorized to act as our agent and redeem this coupon in acceptance with RB Coupon Redemption Policy: face value plus 8¢. Send coupons to: Reckitt Benckiser LLC. Inmar Brand Solutions Dept. 26600, Mfr Rcv Office, 801 Union Pacific Blvd STE 5, Laredo, TX 78045-9475. Cash value 1/100 of 1¢. Good only in the U.S.A. Void where prohibited. © 2023 Reckitt Benckiser LLC",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/758/333758_fafd7842-e163-428d-9072-2a3eba14def2.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100192002031e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1920077182,
                    1920078849,
                    1920081143,
                    1920081145,
                    1920081700,
                    1920080296,
                    1920082159,
                    1920097181,
                    1920049128
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Lysol®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16262,
            "PromotionName": "Save $1.00 ONE Tide Simply PODS Laundry Deterge (178644)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Simply Pods",
            "StartDate": "2023-01-15T03:16:22.057",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Tide Simply PODS Laundry Detergent 20 ct or larger (excludes Tide Simply Laundry Detergent and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/795/333795_998a2b07-d045-4823-a7cb-7624b088aa20.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001787e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700075230,
                    3700075235,
                    3700079963,
                    3700079964
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Simply Pods"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16263,
            "PromotionName": "Save $2.00 ONE Gain Liquid Laundry Detergent 65 (178695)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gain Laundry Deter",
            "StartDate": "2023-01-15T03:16:22.087",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Gain Liquid Laundry Detergent 65-92 oz OR Gain Powder Laundry Detergent 40 ld (excludes Gain Flings, Gain Ultra Flings, Gain Liquid Fabric Softeners, Gain Essential Oils, Gain Fireworks, Gain Sheets and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/910/333910_4bf44c69-09f2-4a91-a95c-b3393936d0e2.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721787e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700097214,
                    3700097649,
                    3077200719,
                    3700055867,
                    3700076124,
                    3700076971,
                    3700077179,
                    3700077944,
                    3077202413
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gain Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16264,
            "PromotionName": "Save $2.00 ONE Gain Liquid Fabric Softener 90-1 (178640)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gain Fabric Enhanc",
            "StartDate": "2023-01-15T03:16:22.103",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Gain Liquid Fabric Softener 90-129 oz OR Gain Fireworks In-Wash Scent Boosters 10-14.8 oz OR Gain Sheets 160-250 ct (excludes Gain Flings, Gain Ultra Flings, Gain Liquid/Powder Laundry Detergent, Gain Essential Oils and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/901/333901_1a6ed0ca-c4d5-4a70-b9e0-cd246dc88206.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721786e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700010750,
                    3700092510,
                    3700098450,
                    3700076315,
                    3700076316,
                    3700076317,
                    3700077754,
                    3700076342,
                    3700076343,
                    3700098434,
                    3700098448,
                    3077200303
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gain Fabric Enhancer"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16266,
            "PromotionName": "Save $1.00 ONE Gain Liquid Laundry Detergent 46 (178696)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gain Laundry Deter",
            "StartDate": "2023-01-15T03:16:22.133",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Gain Liquid Laundry Detergent 46 oz OR Gain Powder Laundry Detergent 30 ld OR Ariel Powder Laundry Detergent 66 ld-132 ld (excludes Gain Flings, Gain Ultra Flings, Gain Liquid Fabric Softeners, Gain Essential Oils, Gain Fireworks, Gain Sheets and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/688/333688_969f94a3-445c-4f13-ae21-4531e0f3bb34.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001787e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700055861,
                    3700077129
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gain Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16269,
            "PromotionName": "Save $2.00 ONE Gain Flings Laundry Detergent 24 (178653)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gain Flings Laundr",
            "StartDate": "2023-01-15T03:16:22.21",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Gain Flings Laundry Detergent 24-35 ct (excludes Gain Liquid/Powder Laundry Detergent, Gain Essential Oils, Gain Liquid Fabric Softeners, Gain Fireworks, Gain Sheets, Gain Flings 9 ct and below and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/885/333885_91d3b8ec-78c8-401d-b081-20913905e56b.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001786e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700086756,
                    3700086757,
                    3700091624,
                    3700075051,
                    3700028298,
                    3700086197,
                    3077202428
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gain Flings Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16270,
            "PromotionName": "Save $0.50 ONE Tide Simply Laundry Detergent 46 (178912)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Simply Laundr",
            "StartDate": "2023-01-15T03:16:22.257",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "Save $0.50 ONE Tide Simply Laundry Detergent 46oz or smaller, Downy Liquid Fabric Conditioner 34oz (includes Downy Fresh 50oz), Gain Suavizante Liquid Fabric Softener 50oz, Bounce/Downy Sheets 34-80ct(includes Downy Infusions 90ct, Bounce/Downy WrinkleGuard 20-40ct, Bounce Pet 20-40ct, Bounce Lasting Fresh 20-40ct OR Gain Sheets 34ct), Downy Unstopables In-Wash Scent Boosters 4.3oz OR ERA Laundry Detergent 50oz or smaller (excl. Downy Libre Enjuague, Gain Fireworks, Tide Detergent, Tide PODS, travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/34/011/334011_50deda91-f7b4-4a72-a682-22cf977bf8f5.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001789e+42
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700035751,
                    3700035756,
                    3700035780,
                    3700035804,
                    3700035819,
                    3700080049,
                    3700080066,
                    3700080068,
                    3700080069,
                    3700080070,
                    3700012889,
                    3700089014,
                    3700090814,
                    3700090815,
                    3700082365,
                    3700057071,
                    3700057602,
                    3077200801
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Simply Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16271,
            "PromotionName": "Save $1.50 on Any ONE (1) Lysol® Laundry Saniti (203102)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Lysol",
            "StartDate": "2023-01-15T03:16:22.273",
            "EndDate": "2023-02-27T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 150,
              "DisplaySummary": "Save $1.50 on Any ONE (1) Lysol® Laundry Sanitizer (41 oz. or Larger)",
              "DisplayDetail": "LIMIT ONE (1) COUPON PER PURCHASE OF SPECIFIED PRODUCT AND QUANTITY STATED. NOT TO BE COMBINED WITH ANY OTHER COUPON(S). LIMIT OF TWO (2) LIKE COUPONS IN SAME SHOPPING TRIP. VOID IF REPRODUCED, PURCHASED, TRADED OR SOLD. ANY OTHER USE CONSTITUTES FRAUD. Consumer: You pay any sales tax. Retailer: You are authorized to act as our agent and redeem this coupon in acceptance with RB Coupon Redemption Policy: face value plus 8¢. Send coupons to: Reckitt Benckiser LLC. Inmar Brand Solutions Dept. 26600, Mfr Rcv Office, 801 Union Pacific Blvd STE 5, Laredo, TX 78045-9475. Cash value 1/100 of 1¢. Good only in the U.S.A. Void where prohibited. © 2023 Reckitt Benckiser LLC",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/784/333784_4ce124c0-f197-4043-b70c-8147c3bdeded.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100192002031e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1920095871,
                    1920095872,
                    1920099100
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Lysol®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16272,
            "PromotionName": "Save $1.00 ONE Gain Flings Laundry Detergent 14 (178654)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gain Flings Laundr",
            "StartDate": "2023-01-15T03:16:22.32",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Gain Flings Laundry Detergent 14-20 ct (excludes Gain Ultra Flings, Gain Liquid/Powder Laundry Detergent, Gain Essential Oils, Gain Liquid Fabric Softeners, Gain Fireworks, Gain Sheets, Gain Flings 9 ct and below and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/802/333802_9cfc8527-38d3-49db-85e1-c23f8c222701.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001786e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700086748,
                    3700086749,
                    3700086750,
                    3700086751,
                    3700091622,
                    3700086193
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gain Flings Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16273,
            "PromotionName": "Save $5.50 on any ONE (1) AIR WICK® Essential M (203108)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "AIR WICK",
            "StartDate": "2023-01-15T03:16:22.35",
            "EndDate": "2023-02-13T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 550,
              "DisplaySummary": "Save $5.50 on any ONE (1) AIR WICK® Essential Mist® Starter Kit",
              "DisplayDetail": "LIMIT ONE (1) COUPON PER PURCHASE OF SPECIFIED PRODUCT AND QUANTITY STATED. NOT TO BE COMBINED WITH ANY OTHER COUPON(S). LIMIT OF TWO (2) LIKE COUPONS IN SAME SHOPPING TRIP. VOID IF REPRODUCED, PURCHASED, TRADED OR SOLD. ANY OTHER USE CONSTITUTES FRAUD. Consumer: You pay any sales tax. Retailer: You are authorized to act as our agent and redeem this coupon in acceptance with RB Coupon Redemption Policy: face value plus 8¢. Send coupons to: Reckitt Benckiser LLC. Inmar Brand Solutions Dept. 26600, Mfr Rcv Office, 801 Union Pacific Blvd STE 5, Laredo, TX 78045-9475. Cash value 1/100 of 1¢. Good only in the U.S.A. Void where prohibited. © 2023 Reckitt Benckiser LLC",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/951/333951_734a4d5c-dc3d-49b0-8b61-1d28c82aaa02.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100623382031e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    6233898577,
                    6233898576
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "AIR WICK®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16274,
            "PromotionName": "Save $1.00 ONE Gain Liquid Fabric Softener 41-5 (178639)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gain Fabric Enhanc",
            "StartDate": "2023-01-15T03:16:22.383",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Gain Liquid Fabric Softener 41-51 oz OR Gain Fireworks In-Wash Scent Boosters 5.5-7.2 oz OR Gain Sheets 105-120 ct (excludes Gain Flings, Gain Ultra Flings, Gain Liquid/Powder Laundry Detergent, Gain Essential Oils and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/884/333884_5d11e79a-48dc-48c4-84be-2763f39400a8.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001786e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700043227,
                    3700043228,
                    3700098360,
                    3700098366,
                    3700098440,
                    3700098454,
                    3700099929,
                    3700075791,
                    3700079714,
                    3700079716,
                    3700079718,
                    3700098499,
                    3700077753,
                    3700099931
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gain Fabric Enhancer"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16275,
            "PromotionName": "Save $3.00 ONE Gain Liquid Laundry Detergent 11 (178694)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gain Laundry Deter",
            "StartDate": "2023-01-15T03:16:22.397",
            "EndDate": "2023-02-20T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-15T03:00:00",
              "DisplayEndDate": "2023-02-20T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Gain Liquid Laundry Detergent 113-154 oz OR Gain Powder Laundry Detergent 63 ld-150 ld (excludes Gain Flings, Gain Ultra Flings, Gain Liquid Fabric Softeners, Gain Essential Oils, Gain Fireworks, Gain Sheets and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/907/333907_617e2c23-33d1-4263-949d-eadaa2f7340c.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001787e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700023033,
                    3700027834,
                    3700027861,
                    3700084910,
                    3700084912,
                    3700084915,
                    3700084917,
                    3700084919,
                    3700023032,
                    3700028609,
                    3700086169,
                    3700098333,
                    3700076258,
                    3700076262,
                    3700076973,
                    3700077089,
                    3700077181,
                    3700077196,
                    3700077272,
                    3700077273,
                    3700077953,
                    3700081773
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gain Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16276,
            "PromotionName": "Fuel Extravaganza 020823 Bounty",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Bounty",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700066557,
                    3700066563
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16277,
            "PromotionName": "Fuel Extravaganza 020823 Charmin",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Charmin",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3077201518,
                    3700061790,
                    3077201569,
                    3077201608
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16278,
            "PromotionName": "Fuel Extravaganza 020823 Hershey",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Hershey",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1070006225,
                    3400004280,
                    3400011032,
                    3400013453,
                    3400014058,
                    3400014061,
                    3400021490,
                    3400021492,
                    3400037924,
                    3400043223,
                    3400043227,
                    3400043228,
                    3400046060,
                    3400046062,
                    3400004594,
                    3400001870,
                    3400001871,
                    3400001874,
                    3400001875,
                    3400001872,
                    3400004281,
                    3400022670,
                    3400022672,
                    3400039992,
                    3400049063,
                    3400021582,
                    3400021577,
                    3400024991
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16279,
            "PromotionName": "Fuel Extravaganza 020823 Sweet Chaos Popcorn",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Sweet Chaos",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    2222400650,
                    2222450070,
                    2222450072
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16280,
            "PromotionName": "Fuel Extravaganza 020823 Ben's Original Rice",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Ben's Original",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 5480042356
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16281,
            "PromotionName": "Fuel Extravaganza 020823 Ben's Original Jasmine",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Ben's Original",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 5480042454
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16282,
            "PromotionName": "Fuel Extravaganza 020823 Stauffer's Snaps",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Stauffer's",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7232012441,
                    7232012442
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16283,
            "PromotionName": "Fuel Extravaganza 020823 Waterloo Sparkling Water",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Waterloo",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    81921502026,
                    81921502028,
                    81921502048,
                    81921502022,
                    81921502046,
                    81921502094,
                    81921502077,
                    81921502124,
                    81921502142
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16284,
            "PromotionName": "Fuel Extravaganza 020823 Pompeian Extra Virgin Olive Oil",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pompeian Extra",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7040400005,
                    7040400205,
                    7040400276
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16285,
            "PromotionName": "Fuel Extravaganza 020823 Lil Snapper Pears",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Lil Snapper",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    74183900712,
                    74183900714,
                    74183900719,
                    74183900720
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16286,
            "PromotionName": "Fuel Extravaganza 020823 Sparkling Ice Singles",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Sparkling Ice",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 4,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1657191030,
                    1657191031,
                    1657191032,
                    1657191037,
                    1657191125,
                    1657191126,
                    1657194033,
                    1657194035,
                    1657194034,
                    1657195029,
                    1657195084,
                    1657195085,
                    1657195210,
                    1657195267,
                    1657195396,
                    1657195477,
                    1657195436,
                    1657195535
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16287,
            "PromotionName": "Fuel Extravaganza 020823 Albanese Sour Gummis",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Albanese Sour",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    63441852348,
                    63441852353,
                    63441852356
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16288,
            "PromotionName": "Fuel Extravaganza 020823 Atkins",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Atkins",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    63748002553,
                    63748005502,
                    63748007502,
                    63748007506,
                    63748007705,
                    63748007528,
                    63748007542,
                    63748005506,
                    63748003155,
                    63748005056,
                    63748005450,
                    63748007410,
                    63748007420,
                    63748000020,
                    63748000024,
                    63748000129,
                    63748000132
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16289,
            "PromotionName": "Fuel Extravaganza 020823 Totino's Pizza Rolls",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Totino's Pizza",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4280010904,
                    4280010915,
                    4280010918,
                    4280010921,
                    4280010924,
                    4280010952,
                    4280010953,
                    4280010954
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16290,
            "PromotionName": "ADVANTAGE MAIL 020123 OREO COOKIES",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Oreo Cookies",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-07T23:59:59.997",
            "CustomerSegmentDistribution": {
              "CustomerLevel": "Household",
              "CustomerLimit": 4,
              "CustomerSegments": {
                "CustomerSegmentID": 1
              }
            },
            "TransactionLimit": 4,
            "RetailerNetValueCoupon": {
              "Number": 71051,
              "NetValue": 275
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4400002540,
                    4400002854,
                    4400003202,
                    4400003258,
                    4400004257
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16291,
            "PromotionName": "ADVANTAGE MAIL 020823 WHITE MUSHROOMS",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Mushrooms",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-14T23:59:59.997",
            "CustomerSegmentDistribution": {
              "CustomerLevel": "Household",
              "CustomerLimit": 0,
              "CustomerSegments": {
                "CustomerSegmentID": 1
              }
            },
            "TransactionLimit": 0,
            "RetailerNetValueCoupon": {
              "Number": 71058,
              "NetValue": 128
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3338367500,
                    3338367600
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16292,
            "PromotionName": "ADVANTAGE MAIL 021523 BAKERY PETIT FOURS",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Petit Fours",
            "StartDate": "2023-01-16T00:00:00",
            "EndDate": "2023-02-21T23:59:59.997",
            "CustomerSegmentDistribution": {
              "CustomerLevel": "Household",
              "CustomerLimit": 2,
              "CustomerSegments": {
                "CustomerSegmentID": 1
              }
            },
            "TransactionLimit": 2,
            "RetailerNetValueCoupon": {
              "Number": 71072,
              "NetValue": 698
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    6113,
                    6114
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16293,
            "PromotionName": "Fuel Extravaganza 020823 Popcorners 7 oz.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Popcorners 7oz",
            "StartDate": "2023-01-17T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    81060702070,
                    81060702071,
                    81060702069,
                    81060702166,
                    81060702255,
                    1060702453,
                    81060702453
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16294,
            "PromotionName": "Fuel Extravaganza 020823 Oscar Mayer Subkits 28 oz.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Oscar Mayer Su",
            "StartDate": "2023-01-17T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 4470003171
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16295,
            "PromotionName": "Fuel Extravaganza 020823 Pepperidge Farm Turnovers 12.5 oz.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pepperidge Far",
            "StartDate": "2023-01-17T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    5100007501,
                    5100007502,
                    5100007519,
                    5100007520
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16296,
            "PromotionName": "Fuel Extravaganza 020823 Avocados from Mexico",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Avocados from",
            "StartDate": "2023-01-17T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 3,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4046,
                    4225,
                    87950200193
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16297,
            "PromotionName": "Fuel Extravaganza 020823 El Monterey Breakfast Burritos 8 ct",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "El Monterey Br",
            "StartDate": "2023-01-17T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7100714842,
                    7100714937,
                    7100714159,
                    7100714576
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16298,
            "PromotionName": "Curbside Pickup Tracking",
            "PromotionType": "Tracking",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "",
            "StartDate": "2023-01-17T00:00:00",
            "EndDate": "2023-12-31T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 1,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 718
                }
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16299,
            "PromotionName": "Save $2.00 on any ONE (1) box of merci® Europea (011475)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "merci European Cho",
            "StartDate": "2023-01-18T03:16:22.497",
            "EndDate": "2023-02-20T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-18T03:01:00",
              "DisplayEndDate": "2023-02-16T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 on any ONE (1) box of merci® European Chocolates",
              "DisplayDetail": "CONSUMER: This coupon only good on purchase of product(s) indicated. Coupon cannot be used in com-bination with any other coupon. Valid only USA, APO’s and FPO’s. Void if sold, transferred, reproduced, prohibited, taxed or restricted. You pay any sales tax. LIMIT ONE COUPON PER PURCHASE. RETAILER: DO NOT DOUBLE COUPON. Storck USA. L.P. will reimburse you the face value of the coupon plus 8 cents han-dling if submitted in compliance with our coupon redemption policy. Cash value 1/20¢. Send coupon to: Storck USA, L.P. (#299), NCH Marketing, P.O. Box 880001, El Paso, TX. 88588-0001 ©2023 Storck USA, L.P.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/995/333995_e15f4cb9-96e0-44a5-aff4-5a98f9560ef6.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100727990115e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 7279903557
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "merci® European Chocolates"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16300,
            "PromotionName": "Fuel Extravaganza 020823 Laura Lynn Slider Storage Bags",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "LL Bags",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    8685402343,
                    8685402344
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16301,
            "PromotionName": "Fuel Extravaganza 020823 Laura Lynn Mayonnaise",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "LL Mayonnaise",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 8685401174
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16302,
            "PromotionName": "Fuel Extravaganza 020823 Laura Lynn Liquid Laundry Detergent",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "LL Laundry Det",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    8685406515,
                    8685406516,
                    8685406517,
                    8685406518
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16303,
            "PromotionName": "Fuel Extravaganza 020823 Laura Lynn Blackeye Peas",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "LL Black Eyed",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 8685402113
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16304,
            "PromotionName": "Fuel Extravaganza 020823 Laura Lynn Cream Cheese Bars",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "LL Cream Chees",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    8685401024,
                    8685403359
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16305,
            "PromotionName": "Fuel Extravaganza 020823 Laura Lynn Peanut Oil 3 gal",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "LL Peanut Oil",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 8685407260
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16306,
            "PromotionName": "Fuel Extravaganza 020823 Butterball Turkey Smoked Sausage",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Butterball",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    2265530604,
                    2265530605
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16307,
            "PromotionName": "Fuel Extravaganza 020823 Land O'Frost Premium Meat",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Land O'Frost",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    5190001601,
                    5190001602,
                    5190001603,
                    5190001604,
                    5190001605,
                    5190001606,
                    5190001608,
                    5190001609,
                    5190001610,
                    5190015004,
                    5190015005,
                    5190015003,
                    5190001613,
                    5190015011,
                    5190080740,
                    5190080742,
                    5190080743,
                    5190080744,
                    5190080745,
                    5190080746,
                    5190080747,
                    5190080749
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16308,
            "PromotionName": "Fuel Extravaganza 020823 Bakery Message Cookie 12 in.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Bakery Message",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    5545,
                    5547,
                    5548,
                    5741
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16309,
            "PromotionName": "Fuel Extravaganza 020823 Bakery Bakers Dozen Cookies",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Bakery Bakers",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    5379,
                    6222,
                    6227,
                    6346,
                    6358,
                    6607,
                    6677,
                    6018,
                    6112
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16310,
            "PromotionName": "Fuel Extravaganza 020823 Bakery Cupcakes 12 ct.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Bakery Cupcake",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    5390,
                    5391,
                    5501,
                    5524,
                    5526,
                    5528,
                    6341,
                    5648,
                    5650
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16311,
            "PromotionName": "Fuel Extravaganza 020823 Rotisserie Chicken Salad",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Rotisserie Chi",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Currency",
                "Threshold": 775,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    20607100000,
                    20607700000
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16312,
            "PromotionName": "Fuel Extravaganza 020823 Anti-biotic free Rotisserie Chicken",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Anti-biotic fr",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 8685406667
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16313,
            "PromotionName": "Fuel Extravaganza 020823 Crest Toothpaste 3D White",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Crest 3D",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700075421,
                    3700021930,
                    3700064966,
                    3700064967,
                    3700068758
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16314,
            "PromotionName": "Fuel Extravaganza 020823 Deli Sandwiches 3 pk",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Deli Sandwiche",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    20628500000,
                    20684600000
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16315,
            "PromotionName": "Fuel Extravaganza 020823 Crest Mouthwash",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Crest 3D",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700044982,
                    3700092495,
                    3700094321,
                    3700073485
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16316,
            "PromotionName": "Fuel Extravaganza 020823 Benihana Hibachi Chicken and Rice 1",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Benihana Hibac",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 2100007070
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16317,
            "PromotionName": "Fuel Extravaganza 020823 Baskin Robbins Ice Cream 14 oz",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Baskin Robbins",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    85245500501,
                    85245500503,
                    85245500504,
                    85245500505,
                    85245500545,
                    85245500543,
                    85245500551,
                    85245500553,
                    85245500565,
                    85245500575
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16318,
            "PromotionName": "Fuel Extravaganza 020823 Jimmy Dean Egg Bites 4 oz",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Jimmy Dean Egg",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7790000183,
                    7790000184
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16319,
            "PromotionName": "Fuel Extravaganza 020823 Skinny Pop Sharing Size 6.7 oz.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Skinny Pop Sha",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    81692502027,
                    81692502031
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16320,
            "PromotionName": "Fuel Extravaganza 020823 Chex Mix or Bugles 7.5 - 8.75 oz.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Chex Mix or Bu",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1600015840,
                    1600015940,
                    1600015990,
                    1600028320,
                    1600028370
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16321,
            "PromotionName": "Fuel Extravaganza 020823 Old El Paso Dinner Kits",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Old El Paso Di",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4600028731,
                    4600028732,
                    4600028734,
                    4600028735,
                    4600028736,
                    4600028738,
                    4600043165,
                    4600045062,
                    4600045396,
                    4600012308,
                    4600012315,
                    4600013008
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16322,
            "PromotionName": "Fuel Extravaganza 020823 Swiffer Refills",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Swiffer Refill",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700031822,
                    3700033903,
                    3700041767,
                    3700016944,
                    3700083063,
                    3700080900,
                    3700083052,
                    3700015846
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16323,
            "PromotionName": "Fuel Extravaganza 020823 Frebreze Fabric Unstopables Twin Pa",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Frebreze Fabri",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 3700029664
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16324,
            "PromotionName": "Fuel Extravaganza 020823 Downy Liquid Fabric Enhancer  105 l",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Downy Liquid F",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700029511,
                    3700029516,
                    3700075490
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16325,
            "PromotionName": "Fuel Extravaganza 020823 Downy Dreft Scent Beads 8.6 oz.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Downy Dreft Sc",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700078980,
                    3700078989,
                    3700078997,
                    3700079030,
                    3700079033,
                    3700079089,
                    3700089039
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16326,
            "PromotionName": "Fuel Extravaganza 020823 Febreze Air Effects Twin Pack",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Febreze Air Ef",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700097799,
                    3700097805,
                    3700097810,
                    3700097794,
                    3700097795,
                    3700097809,
                    3700080657,
                    3700080658
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16327,
            "PromotionName": "Fuel Extravaganza 020823 Frebreze Car Vent Clip 3 ct.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Frebreze Car V",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700084564,
                    3077200852
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16328,
            "PromotionName": "Fuel Extravaganza 020823 Luvs Big Packs",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Luvs Big Packs",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700085934,
                    3700085935,
                    3700085936,
                    3700085933,
                    3700085937,
                    3700078449
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16329,
            "PromotionName": "Fuel Extravaganza 020823 Spam 12 oz.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Spam 12 oz.",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3760011544,
                    3760013872,
                    3760016900,
                    3760017534,
                    3760033658
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16330,
            "PromotionName": "Fuel Extravaganza 020823 Pampers Super Packs",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pampers Super",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700086224,
                    3700086225,
                    3700086223,
                    3700076416,
                    3700076469,
                    3700076470,
                    3700076510,
                    3700074968,
                    3700074969,
                    3700075196,
                    3700086222,
                    3700059606,
                    3700059607,
                    3700059627,
                    3700059643,
                    3700086226,
                    3700082876,
                    3700082879,
                    3700082881
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16331,
            "PromotionName": "Fuel Extravaganza 020823 KIND Cereal Bars 6 ct",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "KIND Cereal Ba",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    60265242994,
                    60265242999,
                    60265243008
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16332,
            "PromotionName": "Fuel Extravaganza 020823 Liquid IV 10 ct.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Liquid IV 10 c",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    85002147400,
                    85002147401,
                    85174100845,
                    85174100899
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16333,
            "PromotionName": "Fuel Extravaganza 020823 Olay Total Effects Moisturizers 1.7",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Olay Total Eff",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7560900165,
                    7560900177,
                    7560900278
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16334,
            "PromotionName": "Fuel Extravaganza 020823 Pantene 10.4 - 12 oz.",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pantene 10.4 -",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    8087819495,
                    8087819496,
                    8087819497,
                    8087819499,
                    8087819500,
                    8087819501,
                    8087819502,
                    8087819555,
                    8087819556,
                    8087819557,
                    8087819558,
                    8087819559,
                    8087819560,
                    8087819562,
                    8087819563,
                    8087819564,
                    8087819566,
                    8087819567,
                    8087819569
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16335,
            "PromotionName": "Fuel Extravaganza 020823 Old Spice Sprays",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Old Spice",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1204404511,
                    1204404512,
                    1204404513,
                    1204404514,
                    1204404527
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16336,
            "PromotionName": "Fuel Extravaganza 020823 Secret Clinical Deodorant",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Secret",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700009615,
                    3700017423,
                    3700088435,
                    3700092186,
                    3700092175,
                    3700088515,
                    3700088519,
                    3700092174
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16337,
            "PromotionName": "Fuel Extravaganza 020823 Olay Bodywash",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Olay Bodywash",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700094550,
                    3700094554,
                    3700097475,
                    3700097464,
                    3700097468,
                    3700097473
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16338,
            "PromotionName": "Fuel Extravaganza 020823 Nature Nate's Honey",
            "PromotionType": "Trade",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Nature Nates",
            "StartDate": "2023-01-18T00:00:00",
            "EndDate": "2023-02-28T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3877883016,
                    3877800116,
                    3877873020
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16339,
            "PromotionName": "Save $1.00 on any ONE (1) Klondike® Cones 4ct o (136198)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Klondike",
            "StartDate": "2023-01-22T03:16:45.57",
            "EndDate": "2023-02-14T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-22T03:01:00",
              "DisplayEndDate": "2023-02-07T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 on any ONE (1) Klondike® Cones 4ct or 8ct",
              "DisplayDetail": "LIMIT ONE (1) COUPON PER PURCHASE on products and quantity specified. Void if reproduced, transferred, used to purchase products for resale or where prohibited/regulated by law. Coupon value may not exceed value of item purchased. NO CASH BACK. Consumer pays sales tax. Redeemable at participating retail stores. Valid only in the U.S. NOT VALID IN PUERTO RICO. Retailer: Unilever, Inc. 1370, NCH Marketing Services, P.O. Box 880001, El Paso, TX 88588-0001 will reimburse the face value of this coupon, plus 8c, if submitted in compliance with our redemption policy, available upon request. Cash value 1/100th of 1c. Any use of this coupon not specified herein constitutes fraud. © 2023 UNILEVER",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/863/333863_ef4adab3-3fb5-48dd-be4e-be1d8cc5e91e.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100758561362e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7585600051,
                    7585600052,
                    7585600054
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Foods"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Klondike®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16340,
            "PromotionName": "$3.00 OFF on ANY TWO (2)  Garnier® Fructis® sha (605328)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Garnier Fructis",
            "StartDate": "2023-01-22T03:16:45.617",
            "EndDate": "2023-02-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-22T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 300,
              "DisplaySummary": "$3.00 OFF on ANY TWO (2)  Garnier® Fructis® shampoo, conditioner, treatment, styling or Invisible Dry Shampoo products (exclusions apply)",
              "DisplayDetail": "Excludes 1oz, 2oz, 2.9oz, 3oz sizes, 11.8oz Treat Shampoo or Conditioner, 3-in-1 Hair Mask, trial and travel sizes, twin packs and value packs. CONSUMER: LIMIT ONE COUPON PER PURCHASE on product/quantity specified. NO MORE THAN ONE (1) IDENTICAL COUPON per household per day. ANY OTHER USE CONSTITUTES FRAUD. CONSUMER PAYS ANY SALES TAX. VOID IF SOLD, ALTERED, REPRODUCED, EXCHANGED OR TRANSFERRED. No cash back or credit if coupon exceeds selling price. RETAILER: L’Oréal USA, Inc. will reimburse in accordance with the L’Oréal USA Coupon Redemption Policy, to obtain visit: www.nchmarketing.com. This coupon good only when redeemed by you from the consumer at the time of purchasing product indicated. Any other use constitutes fraud. Void if reproduced or if prohibited, taxed or restricted by law. Good only in the continental USA, Alaska and Hawaii. NOT VALID IN PUERTO RICO. Cash value is 1/100¢. Mail to: L’Oréal USA 509, P.O. Box 880001, El Paso, TX 88588-0001.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/736/333736_6fecee1a-d6b5-4517-a148-6030f5118560.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110106030846053e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    60308426014,
                    60308426015,
                    60308426016,
                    60308426020,
                    60308426022,
                    60308426024,
                    60308400120,
                    60308405098,
                    60308426767,
                    60308426768,
                    60308420971,
                    60308426617,
                    60308442739,
                    60308442740,
                    60308449151,
                    60308449152,
                    60308449162,
                    60308449163,
                    60308449170,
                    60308449171,
                    60308449183,
                    60308449184,
                    60308449189,
                    60308449190,
                    60308449268,
                    60308402685,
                    60308449125,
                    60308449126,
                    60308449180,
                    60308449141,
                    60308449142
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Garnier® Fructis®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16341,
            "PromotionName": "$3.00 OFF on ANY TWO (2) Garnier® Whole Blends® (605327)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Garnier Whole Blen",
            "StartDate": "2023-01-22T03:16:45.633",
            "EndDate": "2023-02-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-22T03:01:00",
              "DisplayEndDate": "2023-01-30T02:59:58.99",
              "DisplayStatus": "Complete",
              "DisplayValue": 300,
              "DisplaySummary": "$3.00 OFF on ANY TWO (2) Garnier® Whole Blends® shampoo, conditioner or treatment products (exclusions apply)",
              "DisplayDetail": "Excludes 3.0 oz travel size, twin packs and value packs. CONSUMER: LIMIT ONE COUPON PER PURCHASE on product/quantity specified. NO MORE THAN ONE (1) IDENTICAL COUPON per household per day. ANY OTHER USE CONSTITUTES FRAUD. CONSUMER PAYS ANY SALES TAX. VOID IF SOLD, ALTERED, REPRODUCED, EXCHANGED OR TRANSFERRED. No cash back or credit if coupon exceeds selling price. RETAILER: L’Oréal USA, Inc. will reimburse in accordance with the L’Oréal USA Coupon Redemption Policy, to obtain visit: www.nchmarketing.com. This coupon good only when redeemed by you from the consumer at the time of purchasing product indicated. Any other use constitutes fraud. Void if reproduced or if prohibited, taxed or restricted by law. Good only in the continental USA, Alaska and Hawaii. NOT VALID IN PUERTO RICO. Cash value is 1/100¢. Mail to: L’Oréal USA 509, P.O. Box 880001, El Paso, TX 88588-0001.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/767/333767_dae37d39-fe68-4559-b2ae-1746c210c34b.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110106030846053e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    60308445935,
                    60308445938,
                    60308445946,
                    60308445949,
                    60308449454,
                    60308449455,
                    60308454331,
                    60308454335,
                    60308445931,
                    60308445933
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Garnier® Whole Blends®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16342,
            "PromotionName": "Valentine 2023 Dozen Roses and Chocolate Dipped Strawberries",
            "PromotionType": "Trade",
            "PromotionFlags": "None",
            "ReceiptText": "Valentines Day",
            "StartDate": "2023-01-26T00:00:00",
            "EndDate": "2023-02-14T23:59:59.997",
            "LoyaltyDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 0
            },
            "TransactionLimit": 0,
            "RetailerFixedValueCoupon": {
              "Number": 71095,
              "CentsOff": 198
            },
            "ProductsQualificationCriteria": {
              "TriggerQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "Products": {
                  "Product": [
                    2957112326,
                    2957112329
                  ]
                }
              },
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 5256
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": {
                "PromotionAttributeID": 5,
                "BoolValue": true
              }
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16343,
            "PromotionName": "Save $3.00 ONE Crest Gum Detoxify, Densify, Den (179510)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Crest Adult Toothp",
            "StartDate": "2023-01-29T03:17:09.757",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Crest Gum Detoxify, Densify, Densify Pro, Enamel Repair &amp; Gum, Gum Pro, Gum Restore, Sensitivity &amp; Gum, Gum &amp; Bacteria Shield, or Breath Purify &amp; Gum 3.0 toothpaste oz or larger (excludes all other variants, kids, and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/902/333902_cb5edc1e-8978-4cb7-bb19-a0cfbc9ba50a.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700075421,
                    3700075419,
                    3700050999,
                    3700064966,
                    3700064967,
                    3077201678,
                    3077201683
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Crest Adult Toothpaste"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16344,
            "PromotionName": "Save $2.30 ONE Febreze Plug Scented Oil Warmer  (179332)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Febreze Plug Warme",
            "StartDate": "2023-01-29T03:17:09.77",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 230,
              "DisplaySummary": "Save $2.30 ONE Febreze Plug Scented Oil Warmer (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/906/333906_7afb2299-fa29-4af6-91e6-60dc235f32fd.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001793e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 3700076985
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Febreze Plug Warmer Air Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16345,
            "PromotionName": "Save $2.00 ONE Oral-B Adult OR Kids Battery Too (179524)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Oral B Power Batte",
            "StartDate": "2023-01-29T03:17:09.787",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Oral-B Adult OR Kid's Battery Toothbrush (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/882/333882_8ca96d77-e22b-4d75-b929-791ac61e24f7.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100690551795e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    6905583313,
                    6905583315,
                    6905583744,
                    6905583833,
                    6905583834,
                    6905512538,
                    6905512569
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Oral B Power Battery Brush"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16346,
            "PromotionName": "Save $2.00 ONE Microban Sanitizing Spray (exclu (179342)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Microban Aerosol S",
            "StartDate": "2023-01-29T03:17:09.833",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Microban Sanitizing Spray (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/996/333996_860120e3-7885-4d16-b057-c450f25423e7.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700048626,
                    3700048665,
                    3077202855
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Microban Aerosol Spray Large"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16347,
            "PromotionName": "Save $2.00 ONE Metamucil Product (excludes tria (179520)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Metamucil Fiber Su",
            "StartDate": "2023-01-29T03:17:09.867",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Metamucil Product (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/669/333669_4ba2c7f2-a561-443a-9eb1-5c412f5dcdd0.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001796e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700040511,
                    3700040514,
                    3700074044,
                    3700074079,
                    3700074084,
                    3700074085,
                    3700074091,
                    3700074092,
                    3700074134,
                    3700011961,
                    3700096914,
                    3700097849,
                    3700074475,
                    3077200277,
                    3700025445,
                    3700077513
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Metamucil Fiber Supplements"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16348,
            "PromotionName": "SAVE $4.00 off ANY TWO (2) Garnier® Nutrisse®,  (605303)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Garnier Haircolor",
            "StartDate": "2023-01-29T03:17:09.88",
            "EndDate": "2023-02-13T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-06T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 400,
              "DisplaySummary": "SAVE $4.00 off ANY TWO (2) Garnier® Nutrisse®, Color Reviver or Olia® haircolor products",
              "DisplayDetail": "CONSUMER: LIMIT ONE COUPON PER PURCHASE on product/quantity specified. NO MORE THAN ONE (1) IDENTICAL COUPON per household per day. ANY OTHER USE CONSTITUTES FRAUD. CONSUMER PAYS ANY SALES TAX. VOID IF SOLD, ALTERED, REPRODUCED, EXCHANGED OR TRANSFERRED. No cash back or credit if coupon exceeds selling price. RETAILER: L’Oréal USA, Inc. will reimburse in accordance with the L’Oréal USA Coupon Redemption Policy, to obtain visit: www.nchmarketing.com. This coupon good only when redeemed by you from the consumer at the time of purchasing product indicated. Any other use constitutes fraud. Void if reproduced or if prohibited, taxed or restricted by law. Good only in the continental USA, Alaska and Hawaii. NOT VALID IN PUERTO RICO. Cash value is 1/100¢. Mail to: L’Oréal USA 509, P.O. Box 880001, El Paso, TX 88588-0001.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/861/333861_95c19cbc-08df-4176-a725-895c81e35b5d.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110106030846053e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    60308424252,
                    60308424255,
                    60308424257,
                    60308424259,
                    60308424261,
                    60308424262,
                    60308424264,
                    60308424266,
                    60308424267,
                    60308424269,
                    60308424270,
                    60308424272,
                    60308424273,
                    60308424414,
                    60308424415,
                    60308424438,
                    60308424440,
                    60308424457,
                    60308424475,
                    60308424522,
                    60308424523,
                    60308422356,
                    60308422357,
                    60308405593,
                    60308402737
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Garnier® Haircolor"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16349,
            "PromotionName": "Save $1.00 ONE Tide purclean Laundry Detergent  (179408)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Purclean Dete",
            "StartDate": "2023-01-29T03:17:09.897",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Tide purclean Laundry Detergent 34 oz (excludes Tide PODS, Tide Rescue, Studio by Tide Laundry Detergent, Tide Simply Laundry Detergent, Tide Simply PODS, Tide Detergent 10 oz and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/722/333722_98bceaa9-887b-4049-8714-f91c73854ed7.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700042044,
                    3700043107
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Purclean Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16350,
            "PromotionName": "Save $1.00 ONE Oral-B Glide manual floss 1pk OR (179496)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Oral B Glide-Floss",
            "StartDate": "2023-01-29T03:17:09.913",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Oral-B Glide manual floss 1pk OR Oral-B Glide floss picks 60ct and 75ct (excludes Essential floss, Satin floss, Oral-B Fresh Mint Picks).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/875/333875_8c5198e8-e8c4-483b-98c4-a6197c35821c.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.11000300411795e+57
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700003866,
                    3700046953,
                    3700046956,
                    3700046967,
                    3700046974,
                    6830568631,
                    3700020198,
                    30041010385,
                    3700020339
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Oral B Glide-Floss-Picks"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16351,
            "PromotionName": "Save $5.00 THREE Old Spice Anti-Perspirant/Deod (179540)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Old Spice Body Spr",
            "StartDate": "2023-01-29T03:17:09.96",
            "EndDate": "2023-02-13T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 500,
              "DisplaySummary": "Save $5.00 THREE Old Spice Anti-Perspirant/Deodorant, Bodywash, Sprays, OR Hand &amp; Body Lotion (excludes High Endurance and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/877/333877_fb0d7a3d-2ce7-4f8c-adf4-ce98f5beaf92.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100120441795e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 3,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1204438970,
                    1204401113,
                    1204401560,
                    1204401561,
                    1204401572,
                    3700016770,
                    3700026790,
                    1204403750,
                    1204403751,
                    1204403752,
                    1204403753,
                    1204403759,
                    1204403807,
                    1204401643,
                    1204403861,
                    1204403867,
                    1204404003,
                    1204404005,
                    3700084257,
                    3700086680,
                    1204403993,
                    1204403994,
                    1204404089,
                    1204404108,
                    1204404128,
                    1204404130,
                    3700090529,
                    3700086423,
                    3700094465,
                    3700094469,
                    3700094478,
                    3700094479,
                    3700094480,
                    3700048010,
                    3700094527,
                    3700094530,
                    3700094531,
                    1204403963,
                    1204403991,
                    3700072974,
                    3700072977,
                    3700073034,
                    3700097144,
                    3700098324,
                    3700098326,
                    3700073388,
                    3700073413,
                    3700073362,
                    3700078529,
                    3700078530,
                    1204403756,
                    1204403869,
                    1204403969,
                    3700098325,
                    1204402983,
                    1204403000,
                    1204403999,
                    1204404357,
                    1204402036,
                    1204402999,
                    1204404434,
                    1204404437,
                    1204404492,
                    1204404494,
                    1204404511,
                    1204404512,
                    1204404513,
                    1204404514,
                    1204404527,
                    1204404532,
                    1204404536,
                    1204404589
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Old Spice Body Spray"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16352,
            "PromotionName": "Save $1.00 ONE Crest Toothpaste 2.7 oz or more  (179503)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Crest Toothpaste",
            "StartDate": "2023-01-29T03:17:10.007",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Crest Toothpaste 2.7 oz or more (excludes Crest Cavity, Regular, Base Baking Soda, Tartar Control/Protection, F&amp;W Pep Gleem, Gum Variants, Brilliance, 3DW Whitening Therapy, 3DW Professional, Aligner Care, Densify, Kids, More Free packs, and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/976/333976_ab0704c8-f68c-4b0a-be65-3b479f4d24a0.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001796e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700006221,
                    3700038590,
                    3700038593,
                    3700041352,
                    3700042728,
                    3700042734,
                    3700045308,
                    3700022879,
                    3700026148,
                    3700041546,
                    3700042729,
                    3700084064,
                    3700087734,
                    3700094776,
                    3700097133,
                    3700097658,
                    3700097659,
                    3700097667,
                    3700097669,
                    3700097671,
                    3700097672,
                    3700097673,
                    3700097677,
                    3700097678,
                    3700097679,
                    3700097685,
                    3700097688,
                    3700097689,
                    3700074222,
                    3700085165,
                    3700085167,
                    3700085193,
                    3700085217,
                    3700085364,
                    3700090724,
                    3700090729,
                    3700090785,
                    3700039603,
                    3700040027,
                    3700040028,
                    3700040061,
                    3700040066,
                    3700040073,
                    3700048029,
                    3700040128,
                    3700055534,
                    3700055536,
                    3700067038,
                    3700071075,
                    3700071078,
                    3700071090,
                    3700071170,
                    3700071178,
                    3700087485,
                    3700080896,
                    3700081027,
                    3700081919,
                    3700081995,
                    3700084121,
                    3700084397,
                    3700084414,
                    3700084417,
                    3700080973
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Crest Toothpaste"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16353,
            "PromotionName": "Save $3.50 off any TWO (2) AVEENO® Baby Product (054119)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "AVEENO",
            "StartDate": "2023-01-29T03:17:10.02",
            "EndDate": "2023-02-27T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-13T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 350,
              "DisplaySummary": "Save $3.50 off any TWO (2) AVEENO® Baby Products (excluding trial &amp; travel sizes, gift sets, &amp; 25 &amp; 64 ct wipes)",
              "DisplayDetail": "CONSUMER: This coupon good only on purchase of product indicated. Any other use constitutes fraud. COUPON CANNOT BE BOUGHT, TRANSFERRED OR SOLD. LIMIT ONE COUPON PER PURCHASE AND ONE COUPON PER CUSTOMER. VOID IF TAXED, RESTRICTED OR PROHIBITED BY LAW. VOID IF COPIED OR EXPIRED. RETAILER: Johnson &amp; Johnson Consumer Inc. will reimburse you for the face value of this coupon plus 8¢ handling if submitted in compliance with Johnson &amp; Johnson Consumer Inc. Coupon Redemption Policy. Coupons are void where prohibited, taxed, or otherwise restricted by law. Cash Redemption Value 1/100 cent. Send coupons to: Johnson &amp; Johnson Consumer Inc. 1453, NCH, P.O. Box 880001, El Paso, TX 88588-0001. © J&amp;JCI 2023",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/825/333825_3ab95603-c406-42fa-a1e1-36cf3b41d4ac.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110003813705411e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    38137003645,
                    38137003662,
                    38137003664,
                    38137003665,
                    38137003802,
                    38137101844,
                    38137101845,
                    38137102390,
                    38137119196
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "AVEENO®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16354,
            "PromotionName": "Save $3.00 ONE BOX Pampers Easy Ups Training Un (179447)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pampers Easy Ups-U",
            "StartDate": "2023-01-29T03:17:10.067",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE BOX Pampers Easy Ups Training Underwear (excludes trial/travel size)",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/973/333973_4bfebb57-35ab-43ad-b9b8-5eed9b148165.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700076416,
                    3700076469,
                    3700076470,
                    3700076510
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pampers Easy Ups-Underjams"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16355,
            "PromotionName": "Save $0.50 ONE Safeguard Liquid Hand Soap OR Ha (179494)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Safeguard Hand Soa",
            "StartDate": "2023-01-29T03:17:10.083",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "Save $0.50 ONE Safeguard Liquid Hand Soap OR Hand Sanitizer (excludes 2 oz and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/944/333944_e859e824-2306-4ce8-864a-a152a6120a7d.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721794e+42
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700026316,
                    3700026318,
                    3700079143
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Safeguard Hand Soap"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16356,
            "PromotionName": "Save $3.00 ONE Venus Razor (excludes Gillette P (179532)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gillette Razor-Car",
            "StartDate": "2023-01-29T03:17:10.13",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Venus Razor (excludes Gillette Products, disposables, blade refills and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/789/333789_f7b8f1a0-821f-47dc-8c39-d966e93b52ae.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100474001795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    4740007093,
                    4740009896,
                    4740030041,
                    4740030781,
                    4740065714,
                    4740050387,
                    4740001268,
                    4740067419
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gillette Razor-Cartridges"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16357,
            "PromotionName": "Save $2.00 ONE 9 Elements Foaming Dish Spray or (179339)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "9 Elements Dish Ca",
            "StartDate": "2023-01-29T03:17:10.13",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE 9 Elements Foaming Dish Spray or Liquid Dish Soap (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/900/333900_f9e8bbe8-9318-4040-8bf4-53afa40b5484.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700095622,
                    3700096060,
                    3077202712,
                    3077202713
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "9 Elements Dish Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16358,
            "PromotionName": "Save $2.00 ONE Align Probiotic Supplement Produ (179519)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Align Probiotic Su",
            "StartDate": "2023-01-29T03:17:10.16",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Align Probiotic Supplement Product (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/831/333831_258a310e-1d2c-4a15-b2b1-6b10c6aa966a.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001796e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700014343,
                    3700029417,
                    3700050505,
                    3700077937
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Align Probiotic Supplements"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16359,
            "PromotionName": "Save $1.00 ONE Cascade ActionPacs Dishwasher De (179335)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Cascade Rinse Aid",
            "StartDate": "2023-01-29T03:17:10.193",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Cascade ActionPacs Dishwasher Detergent Tub 30 ct or larger (excludes Platinum Plus, trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/680/333680_ecc56149-6835-4bc3-b767-67bfa0cf65c8.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700014392,
                    3700084464,
                    3700084470,
                    3700018629,
                    3700097717,
                    3700097726,
                    3700098216,
                    3700097720,
                    3700097721,
                    3700097728,
                    3700098208,
                    3700098215,
                    3700080689,
                    3700080676,
                    3700027408,
                    3700027425
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Cascade Rinse Aid"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16360,
            "PromotionName": "Save $0.50 ONE Mr Clean Product (excludes trial (179338)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Mr Clean Home Care",
            "StartDate": "2023-01-29T03:17:10.24",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "Save $0.50 ONE Mr Clean Product (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/997/333997_d47fbbd8-246e-4028-b0c3-659c6a0ad5fe.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+57
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700004249,
                    3700049944,
                    3700080393,
                    3700082038,
                    3700082047,
                    3700086441,
                    3700032563,
                    3700077131,
                    3700078418,
                    3700078429,
                    3700078767,
                    3700078784,
                    3700079127,
                    3700079129,
                    3700079131,
                    3700090618,
                    3700050900,
                    3700051099,
                    3700051107,
                    3700051098
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Mr Clean Home Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16361,
            "PromotionName": "Save $3.00 TWO Head &amp; Shoulders Shampoo, Condit (179658)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Head &amp; Shoulders H",
            "StartDate": "2023-01-29T03:17:10.317",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 TWO Head &amp; Shoulders Shampoo, Conditioner OR Treatments (excludes Clinical and Supreme, and trial/travel size/mask sachet).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/679/333679_34bca950-e737-4b9b-9c6b-5142d172dc5e.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001797e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700001196,
                    3700001198,
                    3700001212,
                    3700001214,
                    3700006194,
                    3700006199,
                    3700006203,
                    3700006205,
                    3700006207,
                    3700006209,
                    3700014308,
                    3700047365,
                    3700047366,
                    3700052022,
                    3700052025,
                    3700087773,
                    3700090621,
                    3700090623,
                    3700091842,
                    3700087380,
                    3700097371,
                    3700073268,
                    3700073313,
                    3700073316,
                    3700073339,
                    3700073353,
                    3700073333,
                    3700078282,
                    3700078283,
                    3700078287,
                    3700078291,
                    3700078294,
                    3700078311,
                    3700078332,
                    3700082247,
                    3700094440,
                    3700094441,
                    3700094390,
                    1720000002,
                    3700050914,
                    3700052340,
                    3700094393,
                    3700053714,
                    3700053451,
                    3700071008,
                    3700073314,
                    3700073344,
                    3700078279,
                    3700078666,
                    3700094442
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Head &amp; Shoulders Hair Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16362,
            "PromotionName": "Save $2.00 on any ONE (1) Package of HUGGIES Di (221279)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "HUGGIES Diapers",
            "StartDate": "2023-01-29T03:17:10.333",
            "EndDate": "2023-02-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-06T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 on any ONE (1) Package of HUGGIES Diapers® (not valid on 9 ct. or less)",
              "DisplayDetail": "Reproduction, alteration, proliferation, or sale of this coupon or its contents is strictly prohibited.Civil and criminal penalties up to $2,000,000 and/or imprisonment may apply.CONSUMER:LIMIT ONE (1) COUPON PER PURCHASE on product/quantity specified.Only 1 coupon per product purchased CANNOT BE COMBINED with any other coupon.Any other use constitutes fraud. VOID IF COPIED, SCANNED, TRANSFERRED, MODIFIED, AUCTIONED, PURCHASED OR SOLD. No cash or credit in excess of shelf price after discounts may be returned to consumer or applied to the transaction.CIC® Member Coupon Integrity ProgramRETAILER:K-C will reimburse you the face value of this coupon plus $.08 handling if submitted in compliance with our Coupon Redemption Policy. Mail coupons or requests for Policy to: Kimberly-Clark 1112, P.O. Box 880001, El Paso, TX 88588-0001.Void where prohibited or restricted. Cash value 1/100 cent. Valid only in the USA, its Territories and Possessions.® Registered Trademark and ™ Trademark of Kimberly-Clark Worldwide, Inc. © KCWW.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/943/333943_416c0598-16f7-4aa9-837d-957211808e14.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100360002212e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3600067330,
                    3600049678,
                    3600049679,
                    3600049680,
                    3600049693,
                    3600049695,
                    3600049697,
                    3600049723,
                    3600049724,
                    3600049706,
                    3600049738,
                    3600051462,
                    3600051469,
                    3600051470,
                    3600051471,
                    3600051472,
                    3600051473,
                    3600051532,
                    3600051533,
                    3600051534,
                    3600051535,
                    3600049499,
                    3600049739,
                    3600053588,
                    3600053589,
                    3600053591,
                    3600054639,
                    3600054642,
                    3600054643,
                    3600054647,
                    3600054648,
                    3600054649,
                    3600054650,
                    3600054652,
                    3600054653,
                    3600054654
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "HUGGIES Diapers®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16363,
            "PromotionName": "Save $1.50 ONE BAG Pampers Swaddlers, Pure OR B (179466)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pampers Diapers",
            "StartDate": "2023-01-29T03:17:10.38",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 150,
              "DisplaySummary": "Save $1.50 ONE BAG Pampers Swaddlers, Pure OR Baby Dry Diapers (excludes trial/travel size)",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/775/333775_8ca8068e-7a1e-4997-bece-15b19e7f7a55.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700042022,
                    3700042023,
                    3700042024,
                    3700028052,
                    3700028066,
                    3700028519,
                    3700028522,
                    3700028550,
                    3700050481,
                    3700086208,
                    3700086209,
                    3700086210,
                    3700086211,
                    3700086212,
                    3700086213,
                    3700074897,
                    3700074953,
                    3700074956,
                    3700074958,
                    3700074959,
                    3700074960,
                    3700075252,
                    3700082835,
                    3700082836,
                    3700082842,
                    3700082843
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pampers Diapers"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16364,
            "PromotionName": "Save $1.00 ONE Always DISCREET Incontinence Pro (179474)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Always Discreet In",
            "StartDate": "2023-01-29T03:17:10.397",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Always DISCREET Incontinence Product 20ct or smaller (excludes Always DISCREET Boutique and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/820/333820_c545ec09-043a-4107-b278-0779714c78b4.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700088700,
                    3700088736,
                    3700088757,
                    3700088761,
                    3700086648
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Always Discreet Incontinence"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16365,
            "PromotionName": "Save $2.00 ONE Fixodent Adhesive Twin, Triple o (179500)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Fixodent Denture A",
            "StartDate": "2023-01-29T03:17:10.427",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Fixodent Adhesive Twin, Triple or Quad Pack 2.0 oz or larger (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/914/333914_7558a7ea-fa38-4b1e-b90d-08542fd57627.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700030893,
                    3700024628
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Fixodent Denture Adhesive"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16366,
            "PromotionName": "Save $5.00 ONE Crest 3DWhitestrips Teeth Whiten (179525)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Crest Whitestrips",
            "StartDate": "2023-01-29T03:17:10.443",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 500,
              "DisplaySummary": "Save $5.00 ONE Crest 3DWhitestrips Teeth Whitening Kit (excludes Noticeably White, Classic White and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/709/333709_706fd719-254b-45a5-b8f9-79726a7a677b.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110108897141795e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    88971400003,
                    88971400005,
                    88971400042,
                    88971400043,
                    88971400044,
                    88971400046
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Crest Whitestrips"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16367,
            "PromotionName": "Save $0.50 TWO Pampers Wipes 56 ct or higher (e (179457)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Baby Wipes",
            "StartDate": "2023-01-29T03:17:10.473",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "Save $0.50 TWO Pampers Wipes 56 ct or higher (excludes Sweet Dreams and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/835/333835_d2563e71-8772-46f5-9120-94cb1fc024eb.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+42
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700019505,
                    3700019508,
                    3700050193,
                    3700050197,
                    3700050198,
                    3700084541,
                    3700084542,
                    3700087076,
                    3700087087,
                    3700087096,
                    3700087098,
                    3700089398,
                    3700075139,
                    3700075415,
                    3700075416,
                    3700075467,
                    3700075476,
                    3700075477,
                    3700075532,
                    3700075533,
                    3700075536,
                    3700075475,
                    3700075534,
                    3700075473,
                    3700019513,
                    3700075414,
                    3700075522,
                    3700050655,
                    3700057993
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Baby Wipes"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16368,
            "PromotionName": "Save $2.00 ONE Dreft Blissfuls In-Wash Scent Bo (179399)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Dreft Fabric Enhan",
            "StartDate": "2023-01-29T03:17:10.49",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Dreft Blissfuls In-Wash Scent Boosters 8.6-14.8 oz (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/761/333761_4e04acab-f2fe-4e31-b296-926ae410c787.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700076300,
                    3700078980
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Dreft Fabric Enhancer"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16369,
            "PromotionName": "Save $3.00 ONE Tide PODS Laundry Detergent 32 c (179405)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Pods",
            "StartDate": "2023-01-29T03:17:10.52",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Tide PODS Laundry Detergent 32 ct TO 81 ct OR Tide Power PODS 25 ct TO 48 ct (excludes Tide Liquid/Powder Laundry Detergent, Tide Simply, Tide Simply PODS, and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/834/333834_54cedae0-297d-4664-9f87-07ea2a9028f6.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700000780,
                    3700050966,
                    3700050981,
                    3700000460,
                    3700000462,
                    3700000935,
                    3700091781,
                    3700091798,
                    3700000992,
                    3700000995,
                    3700000997,
                    3700000998,
                    3700091734,
                    3700093045,
                    3700095681,
                    3700095683,
                    3700097783,
                    3700097828,
                    3700075082,
                    3700076162,
                    3700075073,
                    3700076161,
                    3700093043,
                    3700097784,
                    3077202430,
                    3077202432,
                    3077203222,
                    3700097785
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Pods"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16370,
            "PromotionName": "Save $1.00 ONE Always Ultra OR Maxi Pads (14 ct (179493)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Always Menstrual C",
            "StartDate": "2023-01-29T03:17:10.55",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Always Ultra OR Maxi Pads (14 ct OR higher) OR Always ZZZs Pads OR Underwear (3 ct OR higher) OR Always Intimate Care Washes &amp; 40 ct Wipes (excludes Always Liners, Always Infinity, Always Radiant, Always Pure Cotton, Always Discreet)",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/818/333818_dff3c17c-2f91-42ec-9646-d2de85023a7b.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700007553,
                    3700030165,
                    3700030495,
                    3700030563,
                    3700030565,
                    3700030566,
                    3700030655,
                    3700030656,
                    3700030657,
                    3700030659,
                    3700030662,
                    3700031484,
                    3700032494,
                    3700042521,
                    3700060040,
                    3700066381,
                    3700011078,
                    3700017901,
                    3700017902,
                    3700028159,
                    3700089033,
                    3700088922,
                    3700088930,
                    3700089028,
                    3700089907,
                    3700098347,
                    3700098729,
                    3700089030,
                    3700089908,
                    3700099089,
                    3700099095,
                    3077203339,
                    3077203341,
                    3077203352,
                    3077203366,
                    3077203369,
                    3077203399
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Always Menstrual Care Pads"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16371,
            "PromotionName": "Save $1.00 ONE Pantene Product including Gold S (179507)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pantene Hair Care",
            "StartDate": "2023-01-29T03:17:10.63",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Pantene Product including Gold Series and Truly Collections (excludes Conditioner Mix-ins, Generation Beauty, Intense Rescue Shots, Nutrient Blends Collection, Miracle Rescue, Non-Wash Collection, One Step Nourishing Mask and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/681/333681_bd026003-ec95-4832-87c1-c1c29881131e.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100808781796e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    8087800061,
                    8087800550,
                    8087800830,
                    8087802612,
                    8087800218,
                    8087800406,
                    8087800899,
                    8087804031,
                    8087804032,
                    8087804216,
                    8087804217,
                    8087804218,
                    8087804219,
                    8087804220,
                    8087804222,
                    8087804223,
                    8087804225,
                    8087804226,
                    8087804227,
                    8087804228,
                    8087804230,
                    8087804231,
                    8087804233,
                    8087804235,
                    8087804236,
                    8087804238,
                    8087804249,
                    8087804250,
                    8087804252,
                    8087804253,
                    8087804254,
                    8087804255,
                    8087804256,
                    8087804257,
                    8087804258,
                    8087804259,
                    8087804260,
                    8087804261,
                    8087804263,
                    8087804266,
                    8087804267,
                    8087804268,
                    8087804269,
                    8087804302,
                    8087804303,
                    8087804311,
                    8087804313,
                    8087804485,
                    8087804489,
                    8087804494,
                    8087804495,
                    8087805443,
                    8087805449,
                    8087805720,
                    8087817076,
                    8087806218,
                    8087806220,
                    8087817189,
                    8087804393,
                    8087806316,
                    8087806317,
                    8087817725,
                    8087817726,
                    8087817125,
                    8087817126,
                    8087817205,
                    8087817206,
                    8087817956,
                    8087818093,
                    8087818115,
                    8087818116,
                    8087818118,
                    8087818121,
                    8087818139,
                    8087818254,
                    8087818256,
                    8087818266,
                    8087818268,
                    8087818271,
                    8087818272,
                    8087818281,
                    8087818286,
                    8087818295,
                    8087818617,
                    8087818619,
                    8087818620,
                    8087818616,
                    8087817124,
                    8087818478,
                    8087818479,
                    8087818621,
                    8087818642,
                    8087818643,
                    8087818360,
                    8087819469,
                    8087819473,
                    8087819482,
                    8087819484,
                    8087819486,
                    8087819487,
                    8087819488,
                    8087819489,
                    8087819495,
                    8087819496,
                    8087819497,
                    8087819498,
                    8087819499,
                    8087819500,
                    8087819501,
                    8087819502,
                    8087819555,
                    8087819556,
                    8087819557,
                    8087819558,
                    8087819559,
                    8087819560,
                    8087819562,
                    8087819563,
                    8087819564,
                    8087819566,
                    8087819567,
                    8087819569,
                    8087819588,
                    8087819589
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pantene Hair Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16372,
            "PromotionName": "Save $5.00 THREE Olay Bar 4 ct or larger, Body  (179501)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Olay Body Wash",
            "StartDate": "2023-01-29T03:17:10.677",
            "EndDate": "2023-02-13T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 500,
              "DisplaySummary": "Save $5.00 THREE Olay Bar 4 ct or larger, Body Wash, Rinse-Off Body Conditioner, Liquid Hand Soap OR Hand &amp; Body Lotion Products (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/830/333830_08149c13-f264-433f-847b-aac09e451ed6.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 3,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700002871,
                    3700042431,
                    3700048174,
                    3700048207,
                    7560902342,
                    7560904005,
                    7560904187,
                    3700085583,
                    3700048171,
                    3700048177,
                    3700091653,
                    3700091655,
                    3700094550,
                    3700094557,
                    3700094549,
                    3700094553,
                    3700094554,
                    3700097475,
                    3700097494,
                    3700097464,
                    3700097468,
                    3700097472,
                    3700097473,
                    3700097483,
                    3700074586,
                    3700074594,
                    3700078526,
                    3700078527,
                    3700083046
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Olay Body Wash"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16373,
            "PromotionName": "Save $1.50 ONE Vicks Vapo Product (excludes Day (179516)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Vicks Vapo Cough R",
            "StartDate": "2023-01-29T03:17:10.707",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 150,
              "DisplaySummary": "Save $1.50 ONE Vicks Vapo Product (excludes DayQuil, NyQuil, Sinex, Formula 44, VapoCool Drops, and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/700/333700_ff2414b1-fa4c-47f2-bdf4-e0d4061e75b8.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110103239001795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    32390000361,
                    32390000362,
                    32390004052,
                    32390004058,
                    32390004343
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Vicks Vapo Cough Relief"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16374,
            "PromotionName": "Save $1.00 ONE Crest OR Scope Mouthwash 473 mL  (179523)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Crest-Scope",
            "StartDate": "2023-01-29T03:17:10.74",
            "EndDate": "2023-02-13T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Crest OR Scope Mouthwash 473 mL (16 oz) or larger (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/699/333699_8ea21f1e-242a-4001-91f2-ee34798ff2ca.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001796e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700008987,
                    3700044981,
                    3700044982,
                    3700000443,
                    3700022747,
                    3700022749,
                    3700026882,
                    3700030619,
                    3700048032,
                    3700084023,
                    3700092495,
                    3700094321,
                    3700094322,
                    3700094563,
                    3700094564,
                    3700094566,
                    3700094567,
                    3700094569,
                    3700094570,
                    3700095661,
                    3700095662,
                    3700095664,
                    3700095665,
                    3700095666,
                    3700095667,
                    3700095658,
                    3700081123,
                    3700092557,
                    3700098107,
                    3700098108,
                    3700098209,
                    3700098211,
                    3700073030,
                    3700073485,
                    3700078681,
                    3700078715,
                    3700074789,
                    3700079500,
                    3077201950,
                    3700055825,
                    3700073507,
                    3700081124
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Crest-Scope"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16375,
            "PromotionName": "Save $1.00 ONE Gillette Shave Prep (excludes Ki (179530)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gillette Shave Pre",
            "StartDate": "2023-01-29T03:17:10.753",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Gillette Shave Prep (excludes King C. Gillette, Gillette Foamy, Gillette Series, Gillette Fusion, and Gillette Venus Shave Preps).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/807/333807_90713ddb-4140-41e2-97b5-d2e636792f9f.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100474001796e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 4740066009
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gillette Shave Prep-Skin Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16376,
            "PromotionName": "SAVE 50¢ on any ONE (1) Suave® Antiperspirant D (135878)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Suave",
            "StartDate": "2023-01-29T03:17:10.8",
            "EndDate": "2023-02-20T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-13T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "SAVE 50¢ on any ONE (1) Suave® Antiperspirant Deodorant product (excludes twin packs and trial and travel sizes)",
              "DisplayDetail": "LIMIT ONE (1) COUPON PER PURCHASE on products and quantity specified. Void if reproduced, transferred, used to purchase products for resale or where prohibited/regulated by law. Coupon value may not exceed value of item purchased. NO CASH BACK. Consumer pays sales tax. Redeemable at participating retail stores. Valid only in the U.S. NOT VALID IN PUERTO RICO. Retailer: Unilever, Inc. 1370, NCH Marketing Services, P.O. Box 880001, El Paso, TX 88588-0001 will reimburse the face value of this coupon, plus 8¢, if submitted in compliance with our redemption policy, available upon request. Cash value 1/100th of 1¢. Any use of this coupon not specified herein constitutes fraud. © 2023 UNILEVER",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/668/333668_e657c240-fcf0-49aa-a8e9-7163f8629e55.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100794001358e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7940075150,
                    7940076380,
                    7940076420,
                    7940078490,
                    7940078550,
                    7940000154,
                    7940004889,
                    7940004991,
                    7940006837,
                    7940011924,
                    7940015246
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Suave®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16377,
            "PromotionName": "Save $3.00 ONE Dreft Newborn Laundry Detergent  (179404)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Dreft Laundry Dete",
            "StartDate": "2023-01-29T03:17:10.817",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Dreft Newborn Laundry Detergent 46 oz or larger OR Dreft Active Baby Laundry Detergent 46 oz or larger OR Dreft Pure Gentleness Laundry Detergent 46 oz or larger (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/665/333665_b4dff863-33f5-4704-bc4d-11e164b16921.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700085882,
                    3700092695,
                    3700020826,
                    3700074576,
                    3700074689,
                    3700074759,
                    3700074811
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Dreft Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16378,
            "PromotionName": "Save $1.00 ONE Dawn Powerwash (excludes trial/t (179341)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Dawn Hand Dish Car",
            "StartDate": "2023-01-29T03:17:10.833",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Dawn Powerwash (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/886/333886_01bf7da2-039f-4f41-b3a5-40a660816605.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700040657,
                    3700040683,
                    3700052364,
                    3700052365,
                    3700052366,
                    3700052367,
                    3700065732,
                    3700065739
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Dawn Hand Dish Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16379,
            "PromotionName": "Save $2.00 ONE Vicks DayQuil, NyQuil, OR Formul (179517)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Vicks Cough-Cold R",
            "StartDate": "2023-01-29T03:17:10.863",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Vicks DayQuil, NyQuil, OR Formula 44 Product (excludes 8 ct DayQuil/NyQuil, and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/895/333895_dc7cf9fe-8992-48f8-b862-98bee7d521e8.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100561001795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    32390001424,
                    32390001425,
                    32390001426,
                    32390001427,
                    32390001431,
                    32390001435,
                    32390001436,
                    32390001438,
                    32390001439,
                    32390001440,
                    32390001442,
                    32390001443,
                    32390001432,
                    32390001778,
                    32390003809,
                    32390003812,
                    32390003813,
                    32390003814,
                    32390003815,
                    32390003849,
                    32390001452,
                    32390001479,
                    32390001641,
                    32390003902,
                    32390003904,
                    32390003839,
                    32390003940,
                    32390003941,
                    32390003951,
                    32390003952,
                    32390004120,
                    32390004121,
                    32390004161,
                    32390004162,
                    32390004331,
                    32390004333,
                    32390004489,
                    32390004488
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Vicks Cough-Cold Relief"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16380,
            "PromotionName": "Save $2.00 ONE Tide PODS Laundry Detergent 23 c (179406)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Pods",
            "StartDate": "2023-01-29T03:17:10.893",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Tide PODS Laundry Detergent 23 ct, 26 ct, 31 ct, OR Tide Power PODS Laundry Detergent 18 ct (excludes Tide Liquid/Powder Laundry Detergent, Tide Simply Laundry Detergent, Tide Simply PODS and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/707/333707_3fc016b1-4408-47be-8851-6bbe2d872ec4.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700050960,
                    3700050962,
                    3700089886,
                    3700091614,
                    3700093037,
                    3700097781
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Pods"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16381,
            "PromotionName": "Save $2.00 ONE Downy Rinse 25.5oz OR Downy Liqu (179397)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Downy Fabric Enhan",
            "StartDate": "2023-01-29T03:17:10.94",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Downy Rinse 25.5oz OR Downy Liquid Fabric Conditioner 77-129oz(includes Infusions 48-81oz, Odor Protect 48- 81oz, WrinkleGuard 48-81oz, Intense 40-71oz, Nature Blends 67-103oz), Bounce/Downy Sheets 160-250ct(includes Bounce WrinkleGuard 80-160ct, Bounce Pet 80-160ct, Bounce Lasting Fresh 80-160ct) OR In-Wash Scent Boosters 8.6-14.8oz(includes Downy Light, Unstopables, Fresh Protect, Odor Protect, Infusions), Bounce/Downy Spray Bundle Pack(excludes Downy Fresh 50oz,125 oz, trial/trave size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/735/333735_5d5846bf-6d58-437c-ad7d-7f1935d3265e.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700007312,
                    3700031220,
                    3700039685,
                    3700080168,
                    3700010631,
                    3700010633,
                    3700010776,
                    3700010778,
                    3700024684,
                    3700031826,
                    3700035361,
                    3700024861,
                    3700083442,
                    3700098699,
                    3700075446,
                    3700076293,
                    3700076307,
                    3700076309,
                    3700076310,
                    3700076312,
                    3700076313,
                    3700076314,
                    3700076337,
                    3700005275,
                    3700023542,
                    3700029511,
                    3700029512,
                    3700029516,
                    3700078989,
                    3700078997,
                    3700079000,
                    3700079030,
                    3700079031,
                    3700079033,
                    3700079089,
                    3700089039,
                    3700090707,
                    3700090716,
                    3700090836,
                    3700057069,
                    3700057573,
                    3077205147,
                    3700075490,
                    3700075943,
                    3700087915,
                    3700089222
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Downy Fabric Enhancer"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16382,
            "PromotionName": "Save $1.00 on ONE (1) package of Depend® Produc (221292)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Depend",
            "StartDate": "2023-01-29T03:17:10.973",
            "EndDate": "2023-02-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-06T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 on ONE (1) package of Depend® Products (8 ct. or larger)",
              "DisplayDetail": "Reproduction, alteration, proliferation, or sale of this coupon or its contents is strictly prohibited. Civil and criminal penalties up to $2,000,000 and/or imprisonment may apply. CONSUMER:LIMIT ONE (1) COUPON PER PURCHASE on product/quantity specified. Only 1 coupon per product purchased CANNOT BE COMBINED with any other coupon. Any other use constitutes fraud. VOID IF COPIED, SCANNED, TRANSFERRED, MODIFIED, AUCTIONED, PURCHASED OR SOLD. No cash or credit in excess of shelf price after discounts may be returned to consumer or applied to the transaction. CIC® Member Coupon Integrity Program RETAILER:K-C will reimburse you the face value of this coupon plus $.08 handling if submitted in compliance with our Coupon Redemption Policy. Mail coupons or requests for Policy to: Kimberly-Clark 1112, P.O. Box 880001, El Paso, TX 88588-0001.Void where prohibited or restricted. Cash value 1/100 cent. Valid only in the USA, its Territories and Possessions.® Registered Trademark and ™ Trademark of Kimberly-Clark Worldwide, Inc. © KCWW.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/948/333948_44b95a61-10a0-4db0-80a6-e272f686ca7d.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100360002213e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3600012537,
                    3600012539,
                    3600013792,
                    3600013406,
                    3600035641,
                    3600038531,
                    3600038532,
                    3600038533,
                    3600047922,
                    3600047915,
                    3600047919,
                    3600047920,
                    3600047926,
                    3600047927,
                    3600047930,
                    3600047932,
                    3600047933,
                    3600050981,
                    3600050982,
                    3600050983
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Depend®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16383,
            "PromotionName": "Save $2.00 ONE BAG Pampers Easy Ups Training Un (179448)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pampers Easy Ups-U",
            "StartDate": "2023-01-29T03:17:10.99",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE BAG Pampers Easy Ups Training Underwear (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/782/333782_0edca1aa-ea57-44eb-ac00-1c93389ced1e.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700095995,
                    3700076405,
                    3700076443,
                    3700076456,
                    3700076463,
                    3700076464,
                    3700076465
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pampers Easy Ups-Underjams"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16384,
            "PromotionName": "Save $2.00 TWO VapoCool Drops (18 ct OR 45 ct). (179498)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Vicks Sore Throat",
            "StartDate": "2023-01-29T03:17:11.02",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 TWO VapoCool Drops (18 ct OR 45 ct).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/719/333719_f8673659-3e9d-4ba2-87bc-a92cc5cef0d6.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110103239001795e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    32390003970,
                    32390003968,
                    32390004131,
                    32390004346
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Vicks Sore Throat Relief"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16385,
            "PromotionName": "Save $4.00 TWO Herbal Essences bio:renew Shampo (179535)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Herbal Essences Ha",
            "StartDate": "2023-01-29T03:17:11.083",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 400,
              "DisplaySummary": "Save $4.00 TWO Herbal Essences bio:renew Shampoo, Conditioner OR Styling Products (excludes Masks, 100 mL Shampoo and Conditioners, Color, Body Wash and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/853/333853_3fd5d655-fded-4da7-92cb-b036e3edafd9.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110101906791795e+57
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    19067900001,
                    19067900006,
                    19067900008,
                    19067900011,
                    19067900016,
                    19067900018,
                    19067900026,
                    19067900030,
                    19067900002,
                    19067900012,
                    19067900079,
                    19067900080,
                    19067900134,
                    19067900446,
                    19067900447,
                    19067900448,
                    19067900449,
                    19067900450,
                    19067900451,
                    19067900456,
                    19067900004,
                    19067900014,
                    19067900710,
                    19067900711,
                    19067900770,
                    19067900771,
                    19067900772
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Herbal Essences Hair Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16386,
            "PromotionName": "Save $1.50 ONE BAG Pampers Cruisers 360 FIT Dia (179444)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pampers Cruisers 3",
            "StartDate": "2023-01-29T03:17:11.097",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 150,
              "DisplaySummary": "Save $1.50 ONE BAG Pampers Cruisers 360 FIT Diapers (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/869/333869_52848162-2af2-4c30-b272-18a533a8d609.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700071447,
                    3700071457,
                    3700071477
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pampers Cruisers 360 Fit"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16387,
            "PromotionName": "Save $1.00 ONE Oral-B Adult Manual Toothbrush A (179522)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Oral B Manual Adul",
            "StartDate": "2023-01-29T03:17:11.143",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Oral-B Adult Manual Toothbrush Any Size (excludes Healthy Clean, Fresh and Clean, Bright and Clean, Indicator 1ct and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/770/333770_85599bba-3974-45d9-931a-0c99d7678fc9.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110003004117952e+57
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    30041664765,
                    30041664766,
                    30041666630,
                    30041666631,
                    30041667803,
                    30041668064,
                    30041668821,
                    30041668825,
                    30041010031,
                    30041010003,
                    30041010107,
                    30041010111,
                    30041668302,
                    30041668470,
                    30041668471,
                    30041010486,
                    30041010487,
                    30041010490,
                    30041010639,
                    30041010113,
                    30041010430,
                    30041010504,
                    30041010640,
                    30041010844,
                    30041010629,
                    30041010630
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Oral B Manual Adult Toothbrush"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16388,
            "PromotionName": "Save $3.00 ONE Bag Ninjamas Nighttime Underwear (179449)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Ninjamas Underwear",
            "StartDate": "2023-01-29T03:17:11.16",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Bag Ninjamas Nighttime Underwear (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/894/333894_40466c8d-90e9-4651-afd3-8553d1262489.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700062797,
                    3700062798,
                    3700062802,
                    3700062804
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Ninjamas Underwear"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16389,
            "PromotionName": "Save $2.00 ONE Luvs Diapers (excludes trial/tra (179427)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Luvs Diapers",
            "StartDate": "2023-01-29T03:17:11.19",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Luvs Diapers (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/780/333780_2c2e5f23-752e-4f16-929d-5c143f6416e9.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700026006,
                    3700026010,
                    3700026223,
                    3700026224,
                    3700026229,
                    3700026230,
                    3700026231,
                    3700025720,
                    3700025724,
                    3700025734,
                    3700085922,
                    3700085923,
                    3700085924,
                    3700085925,
                    3700085926,
                    3700085927,
                    3700085934,
                    3700085935,
                    3700085936,
                    3700085921,
                    3700085933,
                    3700085937,
                    3700087073,
                    3700078449
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Luvs Diapers"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16390,
            "PromotionName": "Save $0.25 ONE Puffs Facial Tissue Box OR Cube  (179470)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Puffs Tissues",
            "StartDate": "2023-01-29T03:17:11.207",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 25,
              "DisplaySummary": "Save $0.25 ONE Puffs Facial Tissue Box OR Cube (excludes Puffs To-Go 10-count).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/651/333651_4466507c-878f-40b4-b66f-48d34205ddd4.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+42
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700034431,
                    3700034864,
                    3700035038,
                    3700039346,
                    3700039363,
                    3700084363,
                    3700084736,
                    3700034899,
                    3700035520,
                    3700035295,
                    3700035554,
                    3700035669,
                    3700039383,
                    3700084381
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Puffs Tissues"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16391,
            "PromotionName": "Save $0.25 ONE Charmin Flushable Wipes Product  (179473)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Charmin Toilet Tis",
            "StartDate": "2023-01-29T03:17:11.223",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 25,
              "DisplaySummary": "Save $0.25 ONE Charmin Flushable Wipes Product (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/822/333822_9c9cb819-587a-4d91-a1d1-a34d5382a6b4.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+26
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700079468,
                    3700079240,
                    3700079619
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Charmin Toilet Tissue"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16392,
            "PromotionName": "Save $1.00 on any ONE (1) package of POISE® or  (221296)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Poise",
            "StartDate": "2023-01-29T03:17:11.283",
            "EndDate": "2023-02-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-06T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 on any ONE (1) package of POISE® or One By Poise® Product (Pads or Liners). Not valid on 14-26 ct. Liners or 10 ct. Pads",
              "DisplayDetail": "Reproduction, alteration, proliferation, or sale of this coupon or its contents is strictly prohibited.Civil and criminal penalties up to $2,000,000 and/or imprisonment may apply.CONSUMER:LIMIT ONE (1) COUPON PER PURCHASE on product/quantity specified.Only 1 coupon per product purchased CANNOT BE COMBINED with any other coupon.Any other use constitutes fraud. VOID IF COPIED, SCANNED, TRANSFERRED, MODIFIED, AUCTIONED, PURCHASED OR SOLD. No cash or credit in excess of shelf price after discounts may be returned to consumer or applied to the transaction.CIC® Member Coupon Integrity ProgramRETAILER:K-C will reimburse you the face value of this coupon plus $.08 handling if submitted in compliance with our Coupon Redemption Policy. Mail coupons or requests for Policy to: Kimberly-Clark 1112, P.O. Box 880001, El Paso, TX 88588-0001.Void where prohibited or restricted. Cash value 1/100 cent. Valid only in the USA, its Territories and Possessions.® Registered Trademark and ™ Trademark of Kimberly-Clark Worldwide, Inc. © KCWW.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/965/333965_f689c59c-1fad-4f7a-a961-2504806d3985.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100360002213e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3600019586,
                    3600033591,
                    3600033558,
                    3600033590,
                    3600033592,
                    3600033593,
                    3600033594,
                    3600046995,
                    3600034104
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Poise®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16393,
            "PromotionName": "Save $3.00 ONE Crest 3D White Professional, Cre (179511)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Crest Adult Toothp",
            "StartDate": "2023-01-29T03:17:11.33",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Crest 3D White Professional, Crest 3D White Whitening Therapy Charcoal, Ingredients OR Crest 3D White Brilliance 3.0 oz toothpaste or larger (excludes all other variants, Kids and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/788/333788_27623a39-7f2a-4673-b7ba-90adf1ee94e6.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001796e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700088942,
                    3700093878,
                    3700073345,
                    3700073408,
                    3700047980,
                    3700054174,
                    3700021930,
                    3700068758,
                    3700021887,
                    3700078555
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Crest Adult Toothpaste"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16394,
            "PromotionName": "Save $3.00 TWO Adult Crest Toothpaste 2.7 oz or (179504)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Crest Toothpaste",
            "StartDate": "2023-01-29T03:17:11.41",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 TWO Adult Crest Toothpaste 2.7 oz or more, Crest Mouthwash 473 or larger, Oral-B Adult Manual Toothbrush, Oral-B Glide Floss, Floss Picks, Interdental Brush, Interdental Picks OR Fixodent adhesive 1.4 oz or larger (excludes Crest Cavity, Baking Soda, Tartar Control/Protection, More Free pastes, Kids variants, Indicator, Cavity Defense, &amp; Healthy Clean brushes, and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/730/333730_0364de3c-6634-4f3d-b858-2bcce5b18874.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.11000300411795e+57
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700003866,
                    3700006221,
                    3700008987,
                    3700030757,
                    3700038590,
                    3700038593,
                    3700041352,
                    3700042728,
                    3700042734,
                    3700044981,
                    3700044982,
                    3700045308,
                    3700046953,
                    3700046956,
                    3700046967,
                    3700046974,
                    7666000465,
                    7666000864,
                    7666000866,
                    7666030001,
                    7666030002,
                    7666030021,
                    7666030051,
                    7666072536,
                    7666074064,
                    30041664765,
                    30041664766,
                    30041666630,
                    30041666631,
                    30041667803,
                    3700020341,
                    3700022879,
                    3700026148,
                    3700029972,
                    3700029973,
                    3700030619,
                    3700041546,
                    3700042729,
                    3700048032,
                    6830568631,
                    30041668064,
                    30041668821,
                    30041668825,
                    3700084064,
                    30041010031,
                    3700020198,
                    3700084023,
                    30041010003,
                    3700089667,
                    3700087734,
                    3700088942,
                    3700092495,
                    3700094321,
                    3700094322,
                    30041010107,
                    3700093878,
                    3700094563,
                    3700094564,
                    3700094566,
                    3700094567,
                    3700094569,
                    3700094570,
                    3700094776,
                    3700095661,
                    3700095662,
                    3700095664,
                    3700095665,
                    3700095666,
                    3700095667,
                    30041010111,
                    30041668302,
                    30041668470,
                    30041668471,
                    3700030893,
                    3700071150,
                    3700097133,
                    3700097658,
                    3700097659,
                    3700097667,
                    3700097669,
                    3700097671,
                    3700097672,
                    3700097673,
                    3700097677,
                    3700097678,
                    3700097679,
                    3700097685,
                    3700097688,
                    3700097689,
                    3700081123,
                    3700092557,
                    3700097971,
                    3700098107,
                    3700098108,
                    3700098209,
                    3700098211,
                    3700024628,
                    3700073030,
                    3700073345,
                    3700073408,
                    3700073485,
                    3700074222,
                    3700074227,
                    3700075421,
                    3700075605,
                    30041010486,
                    30041010487,
                    30041010490,
                    3700085165,
                    3700085167,
                    3700085193,
                    3700085217,
                    3700085226,
                    3700085364,
                    3700085379,
                    3700090724,
                    3700090729,
                    3700090785,
                    30041010385,
                    30041010639,
                    3700008298,
                    3700039603,
                    3700040027,
                    3700040028,
                    3700040057,
                    3700040061,
                    3700040066,
                    3700040068,
                    3700040073,
                    3700047980,
                    3700048029,
                    3700051158,
                    3700078681,
                    3700020339,
                    3700040128,
                    3700075419,
                    3700050999,
                    3700054174,
                    3700055534,
                    3700074789,
                    3700079500,
                    6830510023,
                    6830510024,
                    3700055536,
                    30041010113,
                    30041010430,
                    30041010504,
                    3700021930,
                    3700064966,
                    3700064967,
                    3700067038,
                    3700068758,
                    3700071075,
                    3700071078,
                    3700071090,
                    3700071170,
                    3700071178,
                    3700087485,
                    30041010640,
                    30041010844,
                    3077200037,
                    3700073627,
                    3700073639,
                    3700080896,
                    3700081027,
                    3700081092,
                    3700081919,
                    3700081995,
                    3700082024,
                    3700084121,
                    3700084397,
                    3700084414,
                    3700084417,
                    3700072132,
                    3700080973,
                    3077201678,
                    3077201683,
                    3077201950,
                    3700021887,
                    3700055825,
                    3700073507,
                    3700078555,
                    3700081124,
                    3700090734,
                    30041010629,
                    30041010630
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Crest Toothpaste"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16395,
            "PromotionName": "Save $5.00 TWO Pantene Nutrient Blends, Pantene (179534)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pantene Hair Care",
            "StartDate": "2023-01-29T03:17:11.44",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 500,
              "DisplaySummary": "Save $5.00 TWO Pantene Nutrient Blends, Pantene Non-Wash Day Products, Pantene Generation Beauty OR Miracle Rescue Collection (excludes Conditioner Mix-ins, Single Count Intense Rescue Shot and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/842/333842_481eff60-ca3d-45b7-9ced-482ed7d6c3a0.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100808781795e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    8087819095,
                    8087819103,
                    8087819104,
                    8087819105,
                    8087819106,
                    8087819107,
                    8087819108,
                    8087819112,
                    8087819113,
                    8087819114,
                    8087819117,
                    8087819123,
                    8087819127,
                    8087819128,
                    8087819130,
                    8087819132,
                    8087819133,
                    8087819096,
                    8087819244
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pantene Hair Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16396,
            "PromotionName": "Save $1.00 ONE Downy Liquid Fabric Conditioner  (179361)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Downy Fabric Enhan",
            "StartDate": "2023-01-29T03:17:11.487",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Downy Liquid Fabric Conditioner 51oz (includes Infusions 32oz OR Odor Protect 32oz OR WrinkleGuard 25oz OR Nature Blends 44oz) OR Bounce/Downy Sheets 105-120ct (includes Bounce/Downy WrinkleGuard Sheets 50-60ct OR Bounce Pet Sheets 50-60ct OR Bounce Lasting Fresh Sheets 50-60ct) OR In-Wash Scent Boosters 5.5oz (includes Downy Light, Unstopables, Fresh Protect, Odor Protect, Infusions) OR Bounce Spray 9.7oz, Downy Spray 9.7oz (excludes Downy 50 oz and125 oz, trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/899/333899_a5990c3f-549f-4b1d-a20a-8fb27f29c9fb.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700035762,
                    3700035830,
                    3700039300,
                    3700039686,
                    3700080071,
                    3700080252,
                    3700047019,
                    3700082355,
                    3700082366,
                    3700082385,
                    3700082386,
                    3700089332,
                    3700089015,
                    3700091582,
                    3700095283,
                    3700075488,
                    3700083561,
                    3700036238,
                    3700038469,
                    3700080326,
                    3700011762,
                    3700012763,
                    3700088998
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Downy Fabric Enhancer"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16397,
            "PromotionName": "Save $3.00 ONE Always DISCREET Boutique product (179476)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Always Discreet In",
            "StartDate": "2023-01-29T03:17:11.503",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Always DISCREET Boutique products OR any Always Discreet Incontinence Products 20 ct or higher (excludes 24 ct and 26 ct Always Discreet Liners, 20 ct Always Discreet pads and other Always Products and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/649/333649_92b6b418-c2a6-4bf6-812b-a322352ed12a.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700088629,
                    3700088634,
                    3700088658,
                    3700088701,
                    3700088707,
                    3700088727,
                    3700088730,
                    3700088755,
                    3700088759,
                    3700088762,
                    3700072795,
                    3700072810,
                    3700073804,
                    3700086676
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Always Discreet Incontinence"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16398,
            "PromotionName": "Save $1.00 ONE Tide PODS Laundry Detergent 12 c (179418)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Pods",
            "StartDate": "2023-01-29T03:17:11.533",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Tide PODS Laundry Detergent 12 ct-16 ct (excludes Tide Liquid/Powder Laundry Detergent, Tide Simply Laundry Detergent, Tide Simply PODS, Tide PODS 9 ct and below and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/883/333883_bd018494-46d5-4146-88a2-75ac72fd93dc.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700075102,
                    3700097780
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Pods"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16399,
            "PromotionName": "Save $3.00 ONE Downy Rinse 48 oz OR Downy Liqui (179360)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Downy Fabric Enhan",
            "StartDate": "2023-01-29T03:17:11.567",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Downy Rinse 48 oz OR Downy Liquid Fabric Conditioner 164 oz (includes Downy Infusions 101 oz OR Downy WrinkleGuard 120 oz OR Downy Nature Blends 129 oz) OR Bounce WrinkleGuard 180 ct OR Bounce Pet Hair &amp; Lint Guard 180 ct OR Bounce Lasting Fresh Sheets 180 ct OR Downy In-Wash Scent Boosters 20.1-26.5 oz (includes Downy Light, Unstopables, Fresh Protect, Odor Protect, Infusions ) (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/926/333926_f2094c25-1c82-4cfe-8bcc-7e379c700812.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700075448,
                    3700076359,
                    3700076360,
                    3700058533,
                    3700058537,
                    3700058538,
                    3077200401,
                    3077200402,
                    3077200406,
                    3077200446,
                    3077200451,
                    3077200452
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Downy Fabric Enhancer"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16400,
            "PromotionName": "Save $2.00 ONE Cascade Rinse Aid (excludes tria (179337)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Cascade Rinse Aid",
            "StartDate": "2023-01-29T03:17:11.58",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Cascade Rinse Aid (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/787/333787_b6d7e2b7-cfc5-4944-ae88-eaf3f7ef2d59.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700000774,
                    3700089646
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Cascade Rinse Aid"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16401,
            "PromotionName": "Save $2.00 ONE Secret Clinical Antiperspirant / (179468)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Secret Clinical-Es",
            "StartDate": "2023-01-29T03:17:11.597",
            "EndDate": "2023-02-13T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Secret Clinical Antiperspirant / Deodorant (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/646/333646_40da8aca-d2a3-46fb-9f7a-5cb763674bbf.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700009614,
                    3700009615,
                    3700017423,
                    3700022941,
                    3700049694,
                    3700019550,
                    3700085023,
                    3700085051,
                    3700085149,
                    3700088435,
                    3700088511,
                    3700092186,
                    3700092175,
                    3700092490,
                    3700088342,
                    3700088515,
                    3700088519,
                    3700088525,
                    3700092174
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Secret Clinical-Essential Oils"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16402,
            "PromotionName": "Save $0.25 ONE Bounty Paper Towel Product (excl (179471)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Bounty Paper Towel",
            "StartDate": "2023-01-29T03:17:11.66",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 25,
              "DisplaySummary": "Save $0.25 ONE Bounty Paper Towel Product (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/811/333811_15b70c88-cad4-45c6-885f-2623b30a94b1.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+42
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700028727,
                    3700084662,
                    3700084690,
                    3700085852,
                    3700085853,
                    3700092986,
                    3700074714,
                    3700074799,
                    3700074651,
                    3700074698,
                    3700074699,
                    3700074798,
                    3700074800,
                    3700074801,
                    3700074900,
                    3700075720,
                    3700076213,
                    3700076220,
                    3700076227,
                    3700076235,
                    3700047791,
                    3700047792,
                    3700076679,
                    3700074884,
                    3700076209,
                    3700066541,
                    3700066557,
                    3700066563,
                    3700066575,
                    3700066584,
                    3700066920,
                    3700066924,
                    3700066932,
                    3700067002,
                    3700074716,
                    3700065478,
                    3700073743
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Bounty Paper Towels"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16403,
            "PromotionName": "Save $3.00 TWO Head &amp; Shoulders Supreme OR Clin (179656)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Head &amp; Shoulders H",
            "StartDate": "2023-01-29T03:17:11.707",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 TWO Head &amp; Shoulders Supreme OR Clinical Product (excludes All Other Head &amp; Shoulders Products, Sachets and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/876/333876_35100ea0-a284-4138-9246-5a9959a3e611.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001796e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700050769,
                    3700050773,
                    3700050774,
                    3700053847,
                    3700050765,
                    3700067372,
                    3077201686,
                    3077201687,
                    3700067374
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Head &amp; Shoulders Hair Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16404,
            "PromotionName": "Save $0.50 ONE Cascade ActionPacs Dishwasher De (179334)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Cascade Automatic",
            "StartDate": "2023-01-29T03:17:11.8",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "Save $0.50 ONE Cascade ActionPacs Dishwasher Detergent Bags 4 ct or Larger OR Dishwasher Cleaner (excludes, Cascade Platinum Plus, ActionPacs Tubs 30 ct or larger and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/957/333957_db034630-1ef0-4877-b245-74007ba51048.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+42
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700097611,
                    3700097694,
                    3700097695,
                    3700097697,
                    3700097706,
                    3700097707,
                    3700097710,
                    3700097715,
                    3700097730,
                    3700080675,
                    3700080688,
                    3700080704,
                    3700080720,
                    3700080759,
                    3700080761,
                    3700081006,
                    3700082916,
                    3700086030,
                    3700088041,
                    3700088052,
                    3700088053,
                    3700084484,
                    3700026355,
                    3700027445
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Cascade Automatic Dish Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16405,
            "PromotionName": "Save $2.00 ONE Swiffer Product (excludes 1 ct D (179333)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Swiffer Quick Clea",
            "StartDate": "2023-01-29T03:17:11.877",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Swiffer Product (excludes 1 ct Duster, 2 ct Duster and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/843/333843_759dc87f-b639-4428-b01e-fe3545faa726.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700006174,
                    3700008443,
                    3700031821,
                    3700031822,
                    3700033903,
                    3700035154,
                    3700040509,
                    3700041767,
                    3700016944,
                    3700023679,
                    3700023682,
                    3700081788,
                    3700083051,
                    3700083058,
                    3700083063,
                    3700015845,
                    3700080900,
                    3700085823,
                    3700092704,
                    3700092810,
                    3700092814,
                    3700092816,
                    3700083052,
                    3700085824,
                    3700059675,
                    3700015846,
                    3700015848,
                    3700023680,
                    3700026536,
                    3700076471,
                    3700077136,
                    3700077326,
                    3700081789
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Swiffer Quick Clean"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16406,
            "PromotionName": "Save $2.00 ONE 9 Elements Multi-Purpose Cleaner (179340)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "9 Elements Multi-S",
            "StartDate": "2023-01-29T03:17:11.923",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE 9 Elements Multi-Purpose Cleaner, Daily Shower Cleaner or Bathroom Cleaner (excludes trial and travel sizes)",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/937/333937_b11bc90c-496e-421c-a409-95b646e34f8e.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700095086,
                    3700095101,
                    3700095455,
                    3700095601
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "9 Elements Multi-Surface Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16407,
            "PromotionName": "Save $3.00 ONE BOX Pampers Swaddlers, Cruisers, (179426)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pampers Diapers",
            "StartDate": "2023-01-29T03:17:11.97",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE BOX Pampers Swaddlers, Cruisers, OR Baby Dry Diapers (excludes Cruisers 360 FIT, Swaddlers Overnights, and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/803/333803_9efdce7f-b36b-4228-8213-18dbd5975496.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700081884,
                    3700081889,
                    3700081894,
                    3700081941,
                    3700081946,
                    3700081951,
                    3700081950,
                    3700086224,
                    3700086225,
                    3700086223,
                    3700086233,
                    3700086234,
                    3700086360,
                    3700086617,
                    3700074964,
                    3700074965,
                    3700074968,
                    3700074969,
                    3700075196,
                    3700075202,
                    3700075203,
                    3700075239,
                    3700074967,
                    3700086222,
                    3700086226,
                    3700082876,
                    3700082879,
                    3700082881
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pampers Diapers"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16408,
            "PromotionName": "Save $1.00 ONE Tide Laundry Detergent 37 oz OR  (179409)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Laundry Deter",
            "StartDate": "2023-01-29T03:17:11.987",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Tide Laundry Detergent 37 oz OR 46 oz (excludes Tide PODS, Tide purclean, Tide Rescue, Studio by Tide Laundry Detergent, Tide Simply Laundry Detergent, Tide Simply PODS, Tide Detergent 10 oz and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/858/333858_6cc69b66-6742-4659-a885-ff3c86e7a3e2.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700087586,
                    3700087548,
                    3700098509,
                    3700087453,
                    3700040212,
                    3700041823,
                    3700040213,
                    3700041312
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          { 
            "PromotionId": 16409,
            "PromotionName": "Save $5.00 ONE GilletteLabs Exfoliating Labs Ra (179531)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Gillette Razor-Car",
            "StartDate": "2023-01-29T03:17:12.033",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 500,
              "DisplaySummary": "Save $5.00 ONE GilletteLabs Exfoliating Labs Razor OR Blade Refill (GilletteLabs razors/refills only, excludes disposables and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/792/333792_46d5345f-7836-4ec7-adc5-df14e8d48456.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100474001796e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 4740067490
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Gillette Razor-Cartridges"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16410,
            "PromotionName": "Save $2.00 ONE Oral-B Rinse 475 mL (16 oz) or l (179509)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Oral B Special Car",
            "StartDate": "2023-01-29T03:17:12.063",
            "EndDate": "2023-02-13T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Oral-B Rinse 475 mL (16 oz) or larger (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/854/333854_7173f350-1cfd-4022-8e7f-76863205bdea.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110003004117951e+42
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    6830510023,
                    6830510024
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Oral B Special Care Oral Rinse"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16411,
            "PromotionName": "Save $7.00 On Any TWO (2) Air Wick® Scented Oil (203125)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Air Wick",
            "StartDate": "2023-01-29T03:17:12.097",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 700,
              "DisplaySummary": "Save $7.00 On Any TWO (2) Air Wick® Scented Oil Twin Refill, Scented Oil Bonus Starter Kit, Essential Mist® Refill (1ct) or Automatic Spray Refill (1ct)",
              "DisplayDetail": "LIMIT ONE (1) COUPON PER PURCHASE OF SPECIFIED PRODUCT AND QUANTITY STATED. NOT TO BE COMBINED WITH ANY OTHER COUPON(S). LIMIT OF TWO (2) LIKE COUPONS IN SAME SHOPPING TRIP. VOID IF REPRODUCED, PURCHASED, TRADED OR SOLD. ANY OTHER USE CONSTITUTES FRAUD. Consumer: You pay any sales tax. Retailer: You are authorized to act as our agent and redeem this coupon in acceptance with RB Coupon Redemption Policy: face value plus 8¢. Send coupons to: Reckitt Benckiser LLC. Inmar Brand Solutions Dept. 26600, Mfr Rcv Office, 801 Union Pacific Blvd STE 5, Laredo, TX 78045-9475. Cash value 1/100 of 1¢. Good only in the U.S.A. Void where prohibited. © 2023 Reckitt Benckiser LLC",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/774/333774_9a9801d2-b009-43e4-9f0d-08217f3c4555.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100623382031e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    6233877961,
                    6233878283,
                    6233878473,
                    6233879553,
                    6233879717,
                    6233880095,
                    6233880978,
                    6233882291,
                    6233880420,
                    6233885191,
                    6233885175,
                    6233889748,
                    6233891097,
                    6233891101,
                    6233891108,
                    6233891112,
                    6233891110,
                    6233897052,
                    6233897053,
                    6233898552,
                    6233898553,
                    6233898554,
                    6233898317,
                    6233898322,
                    6233898327,
                    6233898332,
                    6233898337,
                    6233899615,
                    6233877914,
                    6233889666,
                    6233898260,
                    6233898325
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Air Wick®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16412,
            "PromotionName": "Save $0.50 off any ONE (1) packages of HUGGIES® (221281)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "HUGGIES Wipes",
            "StartDate": "2023-01-29T03:17:12.143",
            "EndDate": "2023-02-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-06T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "Save $0.50 off any ONE (1) packages of HUGGIES® Wipes (48 ct. or higher)",
              "DisplayDetail": "Reproduction, alteration, proliferation, or sale of this coupon or its contents is strictly prohibited.Civil and criminal penalties up to $2,000,000 and/or imprisonment may apply.CONSUMER:LIMIT ONE (1) COUPON PER PURCHASE on product/quantity specified.Only 1 coupon per product purchased CANNOT BE COMBINED with any other coupon.Any other use constitutes fraud. VOID IF COPIED, SCANNED, TRANSFERRED, MODIFIED, AUCTIONED, PURCHASED OR SOLD. No cash or credit in excess of shelf price after discounts may be returned to consumer or applied to the transaction.CIC® Member Coupon Integrity ProgramRETAILER:K-C will reimburse you the face value of this coupon plus $.08 handling if submitted in compliance with our Coupon Redemption Policy. Mail coupons or requests for Policy to: Kimberly-Clark 1112, P.O. Box 880001, El Paso, TX 88588-0001.Void where prohibited or restricted. Cash value 1/100 cent. Valid only in the USA, its Territories and Possessions.® Registered Trademark and ™ Trademark of Kimberly-Clark Worldwide, Inc. © KCWW.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/934/333934_daebc727-3204-4484-a4ee-45627756c0e7.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100360002212e+57
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3600031803,
                    3600031811,
                    3600031816,
                    3600031890,
                    3600043197,
                    3600043247,
                    3600048749,
                    3600048750,
                    3600048756,
                    3600048762,
                    3600050108,
                    3600050467,
                    3600049441,
                    3600049445,
                    3600049446,
                    3600050100,
                    3600050406,
                    3600048751,
                    3600048752,
                    3600048760,
                    3600049443,
                    3600050129,
                    3600050409
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "HUGGIES® Wipes"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16413,
            "PromotionName": "Save $3.00 on any ONE (1) One A Day® Multivitam (023344)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "One A Day",
            "StartDate": "2023-01-29T03:17:12.173",
            "EndDate": "2023-02-20T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-13T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 on any ONE (1) One A Day® Multivitamin 60 count or larger or any One A Day® Prenatal product",
              "DisplayDetail": "CONSUMER: LIMIT ONE COUPON PER PURCHASE on specified product(s), size(s) and quantity stated. LIMIT OF 4 EXACT SAME COUPONS PER HOUSEHOLD PER DAY. You pay any sales tax. Void if copied, sold, transferred, altered, or auctioned. RETAILER: You are authorized to act as our agent and redeem this coupon at face value on the specified product(s). We will reimburse you for the face value of this coupon plus 8¢ if submitted in compliance with the Bayer HealthCare LLC Coupon Redemption Policy, incorporated herein by reference. USE NOT CONSISTENT WITH THESE TERMS MAY CONSTITUTE FRAUD AND MAY VOID ALL COUPONS SUBMITTED. Send coupons to: Bayer HealthCare LLC 1355, P.O. Box 880001, El Paso, TX 88588-0001. Cash Value, 1/20th of 1¢. Good only in the U.S.A.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/664/333664_9e68bd78-c40c-44ea-b0c6-708e9d4dbf9a.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100165000233e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    1650054589,
                    1650055614,
                    1650055709,
                    1650055818,
                    1650055819,
                    1650055615,
                    1650056870,
                    1650058683,
                    1650058684,
                    1650058695,
                    1650058697,
                    1650058702,
                    1650058703,
                    1650059330
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "One A Day®"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16414,
            "PromotionName": "Get $2.00 off any ONE (1) Package of Pull-Ups,  (221285)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pull-Ups",
            "StartDate": "2023-01-29T03:17:12.207",
            "EndDate": "2023-02-06T02:59:58.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:01:00",
              "DisplayEndDate": "2023-02-06T02:59:58.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Get $2.00 off any ONE (1) Package of Pull-Ups, New Leaf, Goodnites (7ct or higher not valid on trial packs)",
              "DisplayDetail": "Reproduction, alteration, proliferation, or sale of this coupon or its contents is strictly prohibited. Civil and criminal penalties up to $2,000,000 and/or imprisonment may apply. CONSUMER:LIMIT ONE (1) COUPON PER PURCHASE on product/quantity specified. Only 1 coupon per product purchased CANNOT BE COMBINED with any other coupon. Any other use constitutes fraud. VOID IF COPIED, SCANNED, TRANSFERRED, MODIFIED, AUCTIONED, PURCHASED OR SOLD. No cash or credit in excess of shelf price after discounts may be returned to consumer or applied to the transaction. CIC® Member Coupon Integrity Program RETAILER:K-C will reimburse you the face value of this coupon plus $.08 handling if submitted in compliance with our Coupon Redemption Policy. Mail coupons or requests for Policy to: Kimberly-Clark 1112, P.O. Box 880001, El Paso, TX 88588-0001.Void where prohibited or restricted. Cash value 1/100 cent. Valid only in the USA, its Territories and Possessions.® Registered Trademark and ™ Trademark of Kimberly-Clark Worldwide, Inc. © KCWW.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/641/333641_5246d14f-b2ba-46d5-b6f5-b6ec57628bd7.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100360002213e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3600032519,
                    3600041313,
                    3600041314,
                    3600041315,
                    3600041316,
                    3600045150,
                    3600047477,
                    3600047480,
                    3600049379,
                    3600049380,
                    3600051334,
                    3600051335,
                    3600051337,
                    3600051338,
                    3600051342,
                    3600051343,
                    3600051344,
                    3600051353,
                    3600051355,
                    3600051357,
                    3600051358,
                    3600040531,
                    3600040532,
                    3600040533,
                    3600040534,
                    3600045121,
                    3600045122,
                    3600045127,
                    3600045128,
                    3600045130,
                    3600045491,
                    3600045495,
                    3600045131,
                    3600053359,
                    3600053361,
                    3600053362,
                    3600053363,
                    3600053636,
                    3600053637
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pull-Ups"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16415,
            "PromotionName": "Save $2.00 ONE Nervive Product (excludes trial/ (179518)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Nervive Nerve Reli",
            "StartDate": "2023-01-29T03:17:12.237",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Nervive Product (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/653/333653_d3ddd484-f08f-4887-8fee-9543b1c0a975.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100307721795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3077204289,
                    3700049580
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Nervive Nerve Relief"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16416,
            "PromotionName": "Save $2.30 ONE Febreze Air Effects (excludes tr (179343)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Febreze Plug Warme",
            "StartDate": "2023-01-29T03:17:12.253",
            "EndDate": "2023-02-13T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 230,
              "DisplaySummary": "Save $2.30 ONE Febreze Air Effects (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/740/333740_862d4828-c19c-4893-ad3d-b920e5e23c37.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001793e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 3700045536
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Febreze Plug Warmer Air Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16417,
            "PromotionName": "Save $1.00 ONE Prilosec OTC Product. (179521)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Prilosec OTC Heart",
            "StartDate": "2023-01-29T03:17:12.283",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Prilosec OTC Product.",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/672/333672_fe0ebd42-97ce-4e99-b29a-98685fd32c3b.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700035905,
                    3700035906,
                    3700035907,
                    3700080836,
                    3700080934
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Prilosec OTC Heartburn Relief"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16418,
            "PromotionName": "Save $10.00 TWO Oral-B Replacement Brush Heads  (179539)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Oral B Power Refil",
            "StartDate": "2023-01-29T03:17:12.313",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 1000,
              "DisplaySummary": "Save $10.00 TWO Oral-B Replacement Brush Heads 3ct or greater (excludes travel/trial size) OR Oral-B Rechargeable Electric Toothbrush (excludes Pro 500, Vitality, and iO Series).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/864/333864_eba8fc39-7ac5-4bd6-8fad-fab3b9d3eb7b.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100690551796e+44
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 2,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    6905582418,
                    6905512520,
                    6905584201,
                    6905585749,
                    6905585963,
                    6905512650,
                    4740067633,
                    4740067707
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Oral B Power Refill"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16419,
            "PromotionName": "Save $2.00 ONE Oral-B Glide manual floss 2ct an (179497)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Oral B Glide-Floss",
            "StartDate": "2023-01-29T03:17:12.33",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Oral-B Glide manual floss 2ct and 3ct OR Oral-B Glide floss picks 150ct and 225ct (excludes Essential floss, Satin floss, Oral-B Fresh Mint Picks) .",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/796/333796_a67d1fe7-cad9-4d9c-a407-9144b2111e22.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.11000300411795e+57
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700097971,
                    30041010385
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Oral B Glide-Floss-Picks"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16420,
            "PromotionName": "Save $1.00 ONE Fixodent Adhesive 1.4oz or large (179499)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Fixodent Denture A",
            "StartDate": "2023-01-29T03:17:12.36",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Fixodent Adhesive 1.4oz or larger (excludes Twin, Triple or Quad Packs and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/930/333930_899ddbf9-005d-4d3a-a65b-cd3b75cd34d5.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7666000465,
                    7666000864,
                    7666000866,
                    7666030001,
                    7666030002,
                    7666030021,
                    7666030051,
                    7666072536,
                    7666074064,
                    3700089667,
                    3700075605,
                    3700072132
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Fixodent Denture Adhesive"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16421,
            "PromotionName": "Save $5.00 ONE Olay Regenerist Facial Moisturiz (179537)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Olay Regenerist Sk",
            "StartDate": "2023-01-29T03:17:12.407",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 500,
              "DisplaySummary": "Save $5.00 ONE Olay Regenerist Facial Moisturizer, Serum, OR Eye (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/720/333720_27b4823c-1d0a-4e43-a7a8-5997f74d42de.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100756091795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7560900058,
                    7560900739,
                    7560900740,
                    7560900741,
                    7560901078,
                    7560901932,
                    7560903769,
                    7560919221,
                    7560919204,
                    7560919049,
                    7560919503,
                    7560919506,
                    7560919520,
                    7560919593,
                    7560919636,
                    7560919743,
                    7560919807,
                    7560919816,
                    7560919817,
                    7560919818,
                    7560919832,
                    7560919833,
                    7560919834
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Olay Regenerist Skin Care"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16422,
            "PromotionName": "Save $0.25 ONE Charmin Toilet Paper Product (ex (179472)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Charmin Toilet Tis",
            "StartDate": "2023-01-29T03:17:12.5",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 25,
              "DisplaySummary": "Save $0.25 ONE Charmin Toilet Paper Product (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/927/333927_726d2dfb-c968-4d46-9bd8-f8dddcbc03a4.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+42
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700094108,
                    3700094111,
                    3700096607,
                    3700096610,
                    3700096894,
                    3700096897,
                    3700098283,
                    3700016234,
                    3700016309,
                    3700061800,
                    3700061925,
                    3700072669,
                    3700072672,
                    3700085736,
                    3700099857,
                    3700013258,
                    3700060989,
                    3700061324,
                    3700072673,
                    3700072695,
                    3700099862,
                    3700075299,
                    3700075321,
                    3700076545,
                    3700076546,
                    3700076550,
                    3700076556,
                    3700072685,
                    3700072697,
                    3700085735,
                    3700017381,
                    3700076555,
                    3700047302,
                    3700054133,
                    3700079839,
                    3700038851,
                    3700052698,
                    3700052776,
                    3700054140,
                    3700079546,
                    3700052769,
                    3700052778,
                    3700055827,
                    3700056804,
                    3700060821,
                    3700061071,
                    3700061079,
                    3700061111,
                    3700060598,
                    3700096891,
                    3700097344,
                    3077201450,
                    3077201467,
                    3077201518,
                    3700061789,
                    3700061790,
                    3077201569,
                    3077201570,
                    3077201608,
                    3077203154,
                    3077204170,
                    3077204176
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Charmin Toilet Tissue"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16423,
            "PromotionName": "Save $2.00 ONE Tide Antibacterial Spray (exclud (179352)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Antibacterial",
            "StartDate": "2023-01-29T03:17:12.55",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Tide Antibacterial Spray (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/850/333850_d099d621-f46f-4e55-b51e-bc7639b55b86.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001793e+27
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": 3700076533
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Antibacterial Spray"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16424,
            "PromotionName": "Save $5.00 THREE Secret Fresh, Outlast, Dry Spr (179467)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Secret Fresh Colle",
            "StartDate": "2023-01-29T03:17:12.58",
            "EndDate": "2023-02-13T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 500,
              "DisplaySummary": "Save $5.00 THREE Secret Fresh, Outlast, Dry Sprays OR Aluminum Free (2.4 OZ or larger).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/988/333988_381376b6-d7ac-4184-af9c-adb6da60ba22.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 3,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700020370,
                    3700020444,
                    3700020468,
                    3700022982,
                    3700028027,
                    3700080804,
                    3700080805,
                    3700080806,
                    3700080815,
                    3700080819,
                    3700080822,
                    3700080831,
                    3700080832,
                    3700080901,
                    3700080905,
                    3700080997,
                    3700049704,
                    3700085070,
                    3700085073,
                    3700091877,
                    3700091894,
                    3700094867,
                    3700072986,
                    3700072991,
                    3700072992,
                    3700097883,
                    3700097885,
                    3700054825,
                    3700088793,
                    3700080091,
                    3700050031,
                    3700066788,
                    3700080093,
                    3700080100,
                    3700074764
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Secret Fresh Collection"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16425,
            "PromotionName": "Save $3.00 ONE Super Pack of Pampers Pure Prote (179425)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pampers Diapers",
            "StartDate": "2023-01-29T03:17:12.61",
            "EndDate": "2023-02-13T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Super Pack of Pampers Pure Protection Diapers.",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/823/333823_bc63e670-ca21-47b9-9b6e-970e6cbd1b43.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700076932,
                    3700076933,
                    3700076934,
                    3700076935,
                    3700076936,
                    3700059605,
                    3700059606,
                    3700059607,
                    3700059627,
                    3700059643
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Baby &amp; Toddler"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pampers Diapers"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16426,
            "PromotionName": "Save $2.00 ONE Tide Laundry Detergent 69 oz OR  (179351)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Laundry Deter",
            "StartDate": "2023-01-29T03:17:12.627",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Tide Laundry Detergent 69 oz OR Tide Powder Laundry Detergent 35 ld TO 40 ld (excludes Tide PODS, Tide purclean, Tide Rescue, Studio by Tide Laundry Detergent, Tide Simply Laundry Detergent, Tide Simply PODS, Tide Detergent 10 oz and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/862/333862_d4d75f88-6a55-40af-810f-83dacbde0b1b.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700040500,
                    3700027785,
                    3700027790,
                    3700091663
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16427,
            "PromotionName": "Save $1.00 ONE Tide PODS Laundry Detergent 20 c (179407)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Pods",
            "StartDate": "2023-01-29T03:17:12.657",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 100,
              "DisplaySummary": "Save $1.00 ONE Tide PODS Laundry Detergent 20 ct or smaller OR Tide Power PODS Laundry Detergent 8 ct (excludes Tide Liquid/Powder Laundry Detergent, Tide Simply Laundry Detergent, Tide Simply PODS, Tide PODS 9 ct and below and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/857/333857_7a77984e-127a-4e7b-9497-d81f21c00ef8.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001794e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700095583,
                    3700095585,
                    3700095684,
                    3700095688,
                    3700075102,
                    3700076516,
                    3700097780
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Pods"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16428,
            "PromotionName": "Save $2.00 ONE Burts Bees Adult OR Kids Toothpa (179529)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Burts Bees Adult T",
            "StartDate": "2023-01-29T03:17:12.69",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Burt's Bees Adult OR Kids' Toothpaste.",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/841/333841_e0067946-9413-48e4-9a6d-475697504d8c.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110101925391796e+58
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    19253900001,
                    19253900031,
                    19253900059,
                    19253900014,
                    19253900033,
                    19253900083
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Burt's Bees Adult Toothpaste"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16429,
            "PromotionName": "Save $0.50 ONE Pepto Bismol Product (excludes t (179514)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Pepto Bismol Nause",
            "StartDate": "2023-01-29T03:17:12.72",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-13T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 50,
              "DisplaySummary": "Save $0.50 ONE Pepto Bismol Product (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/881/333881_0cb46ab6-53e9-4da5-adea-62195eff1bd4.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110003014917952e+56
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    30149003904,
                    30149003908,
                    30149003928,
                    30149003929,
                    30149003930,
                    30149003942,
                    30149003956,
                    30149003966,
                    30149003977,
                    30149003990,
                    30149010048,
                    30149032047,
                    30149000010,
                    30149000185,
                    30149000207
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Health Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Pepto Bismol Nausea Relief"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16430,
            "PromotionName": "Save $2.00 ONE Olay Facial Cleanser (excludes t (179536)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Olay Skin Care Pro",
            "StartDate": "2023-01-29T03:17:12.75",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 200,
              "DisplaySummary": "Save $2.00 ONE Olay Facial Cleanser (excludes trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/905/333905_6de986bc-98ae-4644-bba6-4ecccf7a0b30.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100756091795e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    7560900164,
                    7560960404,
                    7560904121,
                    7560904122,
                    7560919443,
                    7560919539,
                    7560919549,
                    7560919567,
                    7560919568,
                    7560919578,
                    7560904127,
                    7560904126,
                    7560904128,
                    7560919660,
                    7560919736,
                    7560919737,
                    7560919720,
                    7560919811,
                    7560919812,
                    7560919813,
                    7560919835,
                    7560919396
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Personal Care"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Olay Skin Care Products"
                }
              ]
            },
            "PromotionStatus": "Active"
          },
          {
            "PromotionId": 16431,
            "PromotionName": "Save $3.00 ONE Tide Laundry Detergent 92 oz or  (179350)",
            "PromotionType": "Default",
            "PromotionFlags": "UseTargetsOnly",
            "ReceiptText": "Tide Laundry Deter",
            "StartDate": "2023-01-29T03:17:12.797",
            "EndDate": "2023-02-27T02:58:59.99",
            "CustomerActivatedDistribution": {
              "CustomerLevel": "Card",
              "CustomerLimit": 1,
              "ActivationLimit": 1,
              "DisplayStartDate": "2023-01-29T03:00:00",
              "DisplayEndDate": "2023-02-27T02:58:59.99",
              "DisplayStatus": "Active",
              "DisplayValue": 300,
              "DisplaySummary": "Save $3.00 ONE Tide Laundry Detergent 92 oz or larger OR Tide Powder Laundry Detergent 47 ld or larger (excludes Tide PODS, Tide Rescue, Studio by Tide Laundry Detergent, Tide Simply Laundry Detergent, Tide Simply PODS, Tide Detergent 10 oz and trial/travel size).",
              "DisplayDetail": "Dealer: Submission to Procter &amp;amp; Gamble signifies compliance with 'Requirements for Proper Coupon Redemption.' Please visit this link for coupon terms for proper redemption: http://www.pg.com/en_US/downloads/partners_suppliers/PG_Coupon_Terms_of_Proper_Redemption.pdf. Limit of one coupon per item. Consumer: Limit ONE coupon per purchase of products and quantities stated. Any other use constitutes fraud. Coupons are not authorized if purchasing products for resale. You may pay sales tax. Not valid in Puerto Rico. Limit of one coupon per household. Digital Coupons and paper coupons may not be combined on the purchase of a single item. Specially marked items, such as Clearance or Manager's Specials may not be eligible for Digital Coupons.",
              "ImageURL": "https://origin-cdn.pdn.coupons.com/ext/bussys/cpa/pod/33/754/333754_bb6f2110-5941-46f9-8638-663fe84c3c47.gif"
            },
            "TransactionLimit": 1,
            "RetailerCoupon": {
              "Number": 8.110100370001793e+43
            },
            "ProductsQualificationCriteria": {
              "TargetQualificationCriteria": {
                "QualificationType": "Units",
                "Threshold": 1,
                "IncludeQualifiedProductsInResponse": true,
                "Products": {
                  "Product": [
                    3700008885,
                    3700008886,
                    3700008887,
                    3700011031,
                    3700013789,
                    3700013847,
                    3700013882,
                    3700013902,
                    3700023064,
                    3700023068,
                    3700023089,
                    3700027788,
                    3700027789,
                    3700027791,
                    3700027814,
                    3700081467,
                    3700084990,
                    3700084995,
                    3700084997,
                    3700023087,
                    3700087588,
                    3700087456,
                    3700087547,
                    3700087549,
                    3700087561,
                    3700087420,
                    3700087501,
                    3700090539,
                    3700087546,
                    3700085006,
                    3700087473,
                    3700087517,
                    3700087474,
                    3700098511,
                    3700098512,
                    3700073738,
                    3700075264,
                    3700075390,
                    3700087455,
                    3700023066,
                    3700087562,
                    3700087566,
                    3700040217,
                    3700040218,
                    3700040365,
                    3700040367,
                    3700040690,
                    3700040744,
                    3700041828,
                    3700041829,
                    3700041965,
                    3700025787,
                    3700025788,
                    3077203510,
                    3700057471,
                    3700060554,
                    3700060562,
                    3700060567,
                    3700082561
                  ]
                }
              }
            },
            "PromotionAttributes": {
              "PromotionAttribute": [
                {
                  "PromotionAttributeID": 8,
                  "StringValue": "Household"
                },
                {
                  "PromotionAttributeID": 7,
                  "StringValue": "Tide Laundry Detergent"
                }
              ]
            },
            "PromotionStatus": "Active"
          }
        ]
      }
    };

    this.allProductsData = [];

    // Get promotion id, and products
    for(let i=0; i<=xmlData.QueryPromotionsResponse.Promotion.length-1; i++) {
      if (xmlData['QueryPromotionsResponse']['Promotion'][i]['ProductsQualificationCriteria']) {
        if (xmlData['QueryPromotionsResponse']['Promotion'][i]['ProductsQualificationCriteria']['TargetQualificationCriteria']) {
          //console.log(xmlData['QueryPromotionsResponse']['Promotion'][i]['PromotionId']);
          if (xmlData['QueryPromotionsResponse']['Promotion'][i]['ProductsQualificationCriteria']['TargetQualificationCriteria']['Products']['Product'].length) {
            //console.log(xmlData['QueryPromotionsResponse']['Promotion'][i]['ProductsQualificationCriteria']['TargetQualificationCriteria']['Products']['Product'].length)
            for (let j=0; j<=xmlData['QueryPromotionsResponse']['Promotion'][i]['ProductsQualificationCriteria']['TargetQualificationCriteria']['Products']['Product'].length-1; j++) {
              //console.log(this.couponProductsData += xmlData['QueryPromotionsResponse']['Promotion'][i]['ProductsQualificationCriteria']['TargetQualificationCriteria']['Products']['Product'][j])
              this.allProductsData.push(xmlData['QueryPromotionsResponse']['Promotion'][i]['ProductsQualificationCriteria']['TargetQualificationCriteria']['Products']['Product'][j]);
            }
          } else { // Single product promotion (Not array)
            //console.log(xmlData['QueryPromotionsResponse']['Promotion'][i]['ProductsQualificationCriteria']['TargetQualificationCriteria']['Products']['Product']);
            this.allProductsData.push(xmlData['QueryPromotionsResponse']['Promotion'][i]['ProductsQualificationCriteria']['TargetQualificationCriteria']['Products']['Product'] + ' -> ' + xmlData['QueryPromotionsResponse']['Promotion'][i]['PromotionId']);
          }
        }
      }
    }
  }

}
